var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBackPlanMobile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 375,
    height: 575,
    viewBox: "0 0 375 575",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7001_60015)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 375,
    height: 575,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.347656,
    width: 375,
    height: 812,
    fill: "url(#paint0_linear_7001_60015)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-139.197 696.81V679.035C-139.197 586.528 -66.3596 510.56 25.7238 506.403L33.613 498.336C-66.1312 498.336 -147.083 579.184 -147.083 679.032V696.806H-139.194L-139.197 696.81Z",
    fill: "#BEAEAE",
    stroke: "#232222",
    strokeWidth: 0.578265
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-39.164 696.81V679.035C-39.164 586.532 33.6702 510.56 125.757 506.403L133.646 498.336C33.902 498.336 -47.0498 579.184 -47.0498 679.032V696.806H-39.1606L-39.164 696.81Z",
    fill: "#BEAEAE",
    stroke: "#232222",
    strokeWidth: 0.578265
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.8702 696.81V679.035C60.8702 586.535 133.701 510.56 225.791 506.403L233.68 498.336C133.936 498.336 52.9844 579.184 52.9844 679.032V696.806H60.8736L60.8702 696.81Z",
    fill: "#BEAEAE",
    stroke: "#232222",
    strokeWidth: 0.578265
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.902 696.81V679.035C160.902 586.539 233.729 510.56 325.822 506.403L333.712 498.336C233.967 498.336 153.016 579.184 153.016 679.032V696.806H160.905L160.902 696.81Z",
    fill: "#BEAEAE",
    stroke: "#232222",
    strokeWidth: 0.578265
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.942 696.81V679.035C260.942 586.542 333.767 510.56 425.863 506.403L433.753 498.336C334.008 498.336 253.057 579.184 253.057 679.032V696.806H260.946L260.942 696.81Z",
    fill: "#BEAEAE",
    stroke: "#232222",
    strokeWidth: 0.578265
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.976 696.81V679.035C360.976 586.545 433.796 510.56 525.897 506.403L533.786 498.336C434.042 498.336 353.09 579.184 353.09 679.032V696.806H360.979L360.976 696.81Z",
    fill: "#BEAEAE",
    stroke: "#232222",
    strokeWidth: 0.578265
  }), /*#__PURE__*/React.createElement("path", {
    d: "M741.058 520.395H-374.71V530.723H741.058V520.395Z",
    fill: "#BEAEAE"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.45,
    d: "M-386.966 816.999V569.311L727.995 568.936V816.999H-386.966Z",
    fill: "url(#paint1_linear_7001_60015)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M830.781 567.328V441L-284.796 441V567.328H830.781Z",
    fill: "#C4E1B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M830.785 575.814V557.828L-284.792 557.828V575.814L830.785 575.814Z",
    fill: "url(#paint2_linear_7001_60015)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M490.069 481.843L-28.7496 482.586L72.8502 547.001H459.71L490.069 481.843Z",
    fill: "#FFF5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-75.2233 461.515C-76.7235 460.835 -78.3518 460.483 -79.999 460.483H-283.483L-292.035 469.59H-115.02C-114.023 469.59 -113.044 469.847 -112.176 470.337L-84.7496 485.832L-13.3114 547.001H72.8502L-28.7496 482.586L-75.2233 461.515Z",
    fill: "#FFF5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-13.3114 547.001L-84.7496 485.832H-285.469L-285.096 547.001H-13.3114Z",
    fill: "#FFF5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.341 547.001L623.937 546.63L839.052 547.001L830.956 494.84L604.507 493.869C582.663 493.775 561.125 488.732 541.51 479.12L516.883 467.051C514.116 465.695 515.107 461.529 518.188 461.564L836.738 465.134V452.509L476.745 451.118C468.565 451.087 464.892 461.357 471.237 466.52L490.069 481.843L459.71 547.001H549.341Z",
    fill: "#FFF5F5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-188.49 314.698H-188.51V314.724H-188.49V314.698Z",
    fill: "url(#paint3_linear_7001_60015)",
    fillOpacity: 0.65
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M674.353 236.377L675.348 180.198L677.013 236.537C677.387 236.537 677.693 236.842 677.693 237.214V243.966H678.372C678.746 243.966 679.052 244.271 679.052 244.643V247.366C679.544 247.815 679.876 248.44 679.939 249.148L680.078 250.905C680.296 253.478 680.291 256.066 680.053 258.639L679.949 259.744C679.835 260.984 678.891 261.966 677.693 262.162V268.274H678.372C678.746 268.274 679.052 268.579 679.052 268.951V269.627C679.052 269.999 678.746 270.304 678.372 270.304H677.693V273.678H678.372C678.746 273.678 679.052 273.983 679.052 274.355V275.703C679.052 276.075 678.746 276.38 678.372 276.38H677.693V281.779H678.372C678.746 281.779 679.052 282.083 679.052 282.455V283.804C679.052 284.176 678.746 284.481 678.372 284.481H677.693V285.157H678.372C678.746 285.157 679.052 285.462 679.052 285.834V287.183C679.052 287.555 678.746 287.859 678.372 287.859H677.693V289.208H679.046C679.42 289.208 679.726 289.513 679.726 289.885V294.612C679.726 294.984 679.42 295.289 679.046 295.289H678.367V309.465C678.74 309.465 679.046 309.77 679.046 310.142V311.49C679.046 311.862 678.74 312.167 678.367 312.167V313.515C678.74 313.515 679.046 313.82 679.046 314.192V315.54C679.046 315.912 678.74 316.217 678.367 316.217V331.742H679.721C680.094 331.742 680.4 332.047 680.4 332.419V339.466H685.524C686.266 339.466 686.878 340.07 686.878 340.814V341.863H700.751V337.632C700.751 337.229 700.43 336.903 700.025 336.903C699.62 336.903 699.294 336.578 699.294 336.175V333.607C699.294 333.018 698.811 332.538 698.215 332.538C697.473 332.538 696.949 331.789 697.214 331.091L703.64 314.208C703.837 313.681 704.335 313.334 704.905 313.334H784.971C785.454 313.334 785.894 313.582 786.138 313.996L796.288 331.101C796.661 331.737 796.21 332.538 795.463 332.538C794.944 332.538 794.509 332.961 794.509 333.488V335.55C794.509 336.294 793.907 336.898 793.155 336.898H792.948C792.206 336.898 791.594 337.502 791.594 338.246V341.853H800.499V309.279C800.499 308.943 800.774 308.669 801.111 308.669C801.448 308.669 801.728 308.395 801.728 308.06V295.955C801.728 295.211 802.33 294.607 803.082 294.607H825.424V293.258C825.424 292.514 826.031 291.91 826.778 291.91H832.892C833.489 291.91 834.018 291.522 834.189 290.954L837.332 280.714C837.503 280.146 838.032 279.759 838.629 279.759H915.214C915.956 279.759 916.568 280.363 916.568 281.107V341.858V413.185H-282.46V328.947V325.351C-282.46 324.607 -281.853 324.003 -281.106 324.003H-280.375C-279.628 324.003 -279.021 323.398 -279.021 322.654V316.124C-279.021 315.38 -278.415 314.776 -277.668 314.776H-253.111C-252.364 314.776 -251.757 315.38 -251.757 316.124V322.654C-251.757 323.398 -251.15 324.003 -250.404 324.003H-247.79C-247.058 324.003 -246.467 324.592 -246.467 325.32C-246.467 326.049 -245.876 326.638 -245.145 326.638H-237.754C-237.251 326.638 -236.784 326.917 -236.556 327.361L-231.531 336.893C-231.427 337.084 -231.375 337.301 -231.375 337.518V342.441H-225.556V332.951C-225.556 332.145 -224.384 332.021 -224.213 332.811L-223.902 334.258L-222.06 334.253L-221.869 332.961C-221.76 332.207 -220.676 332.181 -220.536 332.93L-220.287 334.222V334.258L-216.641 334.253L-216.449 332.961C-216.34 332.207 -215.256 332.181 -215.116 332.93L-214.867 334.222V334.258L-213.934 334.253L-213.742 332.961C-213.633 332.207 -212.549 332.181 -212.409 332.93L-212.165 334.222C-212.16 334.227 -212.16 334.243 -212.16 334.243V334.258L-211.9 334.253L-211.709 332.961C-211.6 332.207 -210.516 332.181 -210.376 332.93L-210.127 334.222V334.243V334.258H-209.743L-209.432 332.811C-209.261 332.016 -208.089 332.14 -208.089 332.951V342.441H-193.505V305.332H-193.396L-193.261 304.138C-193.168 303.358 -192.037 303.332 -191.913 304.113L-191.731 305.332H-191.197L-191.062 304.138C-190.963 303.358 -189.833 303.332 -189.719 304.113L-189.511 305.471H-184.335L-184.185 304.138C-184.092 303.358 -182.961 303.332 -182.837 304.113L-182.634 305.471H-182.131L-181.981 304.138C-181.882 303.358 -180.752 303.332 -180.638 304.113L-180.43 305.471H-180.166V314.642H-176.722V294.369H-176.509V294.343V294.302L-176.25 291.837C-176.167 291.016 -174.964 291.031 -174.902 291.853L-174.71 294.317V294.369H-171.551V294.302L-171.292 291.837C-171.209 291.016 -170.006 291.031 -169.943 291.853L-169.752 294.317V294.369H-169.005V276.003H-168.393L-168.222 275.3C-168.045 274.592 -167.029 274.623 -166.894 275.336L-166.769 275.998H-166.334L-163.772 268.594L-162.776 254.067H-162.812C-163.948 254.067 -164.871 253.147 -164.871 252.01C-164.871 250.874 -163.958 249.954 -162.812 249.954C-161.666 249.954 -160.743 250.874 -160.743 252.01C-160.743 253.059 -161.537 253.927 -162.553 254.051L-161.433 268.594L-159.135 275.998H-158.824L-158.321 274.484C-158.108 273.843 -157.18 273.874 -157.019 274.535L-156.661 276.003H-156.615V276.225C-156.609 276.271 -156.609 276.318 -156.615 276.359V294.369H-154.753V294.343V294.302L-154.494 291.837C-154.411 291.016 -153.207 291.031 -153.145 291.853L-152.953 294.317V294.369L-152.824 294.364V294.333C-152.824 294.322 -152.818 294.302 -152.818 294.302L-152.569 291.837C-152.486 291.016 -151.283 291.031 -151.221 291.853L-151.029 294.317C-151.029 294.333 -151.024 294.369 -151.024 294.369H-150.832V314.642H-149.732V305.471H-149.468L-149.261 304.113C-149.136 303.338 -148.005 303.358 -147.917 304.138L-147.762 305.471H-147.269L-147.062 304.113C-146.937 303.338 -145.806 303.358 -145.718 304.138L-145.563 305.471H-140.392L-140.185 304.113C-140.06 303.338 -138.929 303.358 -138.841 304.138L-138.701 305.332H-138.172L-137.98 304.113C-137.856 303.338 -136.725 303.358 -136.637 304.138L-136.497 305.332H-136.253V342.441H-127.499L-127.582 332.031C-127.592 331.231 -126.441 331.086 -126.249 331.866L-125.699 334.113H-125.165L-124.968 332.285C-124.88 331.494 -123.734 331.473 -123.62 332.259L-123.355 334.108H-123.132L-122.935 332.279C-122.847 331.489 -121.701 331.468 -121.587 332.254L-121.322 334.103H-121.099L-120.902 332.274C-120.814 331.484 -119.668 331.463 -119.553 332.248L-119.289 334.098H-118.387L-118.189 332.269C-118.101 331.479 -116.955 331.458 -116.841 332.243L-116.577 334.093H-116.354L-116.156 332.264C-116.068 331.473 -114.922 331.453 -114.808 332.238L-114.523 334.227H-113.657L-113.444 332.264C-113.356 331.473 -112.21 331.453 -112.096 332.238L-111.81 334.227H-111.484L-111.027 332.377C-110.83 331.603 -109.689 331.742 -109.694 332.543L-109.736 342.416H-102.185V320.092C-102.185 319.643 -102.413 319.219 -102.786 318.971L-102.963 318.857C-103.341 318.604 -103.564 318.18 -103.564 317.731V316.899C-103.564 316.155 -102.957 315.551 -102.211 315.551H-102.096C-101.588 315.551 -101.116 315.267 -100.888 314.817L-95.1935 303.751C-94.9601 303.301 -94.4933 303.017 -93.9851 303.017H-54.8598C-54.3307 303.017 -53.8484 303.322 -53.6254 303.797L-48.2835 315.282C-48.2005 315.458 -48.1538 315.654 -48.1538 315.85V320.139C-48.1538 320.474 -47.879 320.748 -47.5419 320.748C-47.2048 320.748 -46.9247 321.022 -46.9247 321.358V342.416H-7.44668L11.9397 325.863C12.1886 325.656 12.4946 325.542 12.8213 325.542H19.9421C20.2688 325.542 20.5852 325.661 20.829 325.873L23.7955 328.446L28.9196 270.191H31.2897L40.9777 342.416H47.1494V317.53C47.1494 317.251 47.2375 316.977 47.3983 316.749L60.5974 298.094C60.7322 297.903 60.9086 297.758 61.1005 297.665V297.185H101.092C101.688 297.185 102.217 297.572 102.389 298.14L105.531 308.38C105.703 308.948 106.232 309.336 106.828 309.336H112.943C113.684 309.336 114.296 309.94 114.296 310.684V346.461H126.494V317.493C126.494 317.235 126.572 316.982 126.712 316.765L138.148 299.034C138.775 298.053 140.269 298.275 140.585 299.396L153.935 346.461H168.861V337.508C168.861 337.105 168.539 336.779 168.135 336.779C167.73 336.779 167.404 336.454 167.404 336.051V333.483C167.404 332.894 166.921 332.414 166.325 332.414C165.583 332.414 165.059 331.665 165.324 330.967L171.75 314.084C171.947 313.557 172.445 313.21 173.015 313.21H208.583C208.909 313.21 209.174 312.952 209.174 312.627C209.174 312.301 208.909 312.043 208.583 312.043H208.292C207.81 312.043 207.416 311.65 207.416 311.17V311.025C207.416 310.462 207.877 310.007 208.437 310.007H225.085C225.806 310.007 226.398 310.591 226.398 311.314V311.748C226.398 312.229 226.003 312.622 225.516 312.622H224.935C224.774 312.622 224.645 312.751 224.645 312.911C224.645 313.071 224.774 313.2 224.935 313.2H253.076C253.558 313.2 253.999 313.448 254.243 313.861L264.392 330.967C264.766 331.603 264.314 332.403 263.568 332.403C263.049 332.403 262.613 332.827 262.613 333.354V335.415C262.613 336.159 262.012 336.764 261.26 336.764H261.047C260.306 336.764 259.694 337.368 259.694 338.112V341.718H268.598V308.468C268.598 308.132 268.873 307.858 269.21 307.858C269.548 307.858 269.828 307.584 269.828 307.249V295.144C269.828 294.4 270.429 293.795 271.181 293.795H324.481C325.222 293.795 325.834 294.4 325.834 295.144V307.249C325.834 307.584 326.109 307.858 326.446 307.858C326.783 307.858 327.063 308.132 327.063 308.468V312.668H340.356L343.369 302.847C343.54 302.279 344.069 301.891 344.666 301.891H383.304C384.045 301.891 384.657 302.496 384.657 303.239V312.668H431.095L436.733 301.695C436.966 301.245 437.433 300.961 437.941 300.961H477.067C477.596 300.961 478.078 301.266 478.301 301.741L483.643 313.226C483.726 313.402 483.772 313.598 483.772 313.794V318.082C483.772 318.418 484.047 318.692 484.384 318.692C484.721 318.692 485.001 318.966 485.001 319.302V341.713H522.903L544.25 323.486H552.382L573.386 341.713H579.086V315.478C579.086 315.2 579.174 314.926 579.335 314.698L592.534 296.043C592.669 295.852 592.845 295.707 593.037 295.614V295.134H633.029C633.625 295.134 634.154 295.521 634.325 296.089L637.468 306.329C637.639 306.897 638.168 307.285 638.764 307.285H644.879C645.621 307.285 646.233 307.889 646.233 308.633V341.708H658.431V340.659C658.431 339.915 659.038 339.311 659.784 339.311H670.966V332.264C670.966 331.892 671.272 331.587 671.646 331.587H672.999V316.062C672.626 316.062 672.32 315.757 672.32 315.385V314.037C672.32 313.665 672.626 313.36 672.999 313.36V312.012C672.626 312.012 672.32 311.707 672.32 311.335V309.987C672.32 309.615 672.626 309.31 672.999 309.31V295.134H672.32C671.946 295.134 671.64 294.829 671.64 294.457V289.73C671.64 289.358 671.946 289.053 672.32 289.053H673.673V287.704H672.994C672.621 287.704 672.315 287.4 672.315 287.028V285.679C672.315 285.307 672.621 285.002 672.994 285.002H673.673V284.326H672.994C672.621 284.326 672.315 284.021 672.315 283.649V282.3C672.315 281.928 672.621 281.624 672.994 281.624H673.673V276.225H672.994C672.621 276.225 672.315 275.92 672.315 275.548V274.2C672.315 273.828 672.621 273.523 672.994 273.523H673.673V270.149H672.994C672.621 270.149 672.315 269.844 672.315 269.472V268.796C672.315 268.424 672.621 268.119 672.994 268.119H673.673V262.038C672.496 261.971 671.511 261.082 671.35 259.899C670.868 256.386 670.847 252.832 671.288 249.319L671.34 248.864C671.433 248.151 671.791 247.536 672.315 247.113V244.483C672.315 244.111 672.621 243.806 672.994 243.806H673.673V237.054C673.673 236.682 673.979 236.377 674.353 236.377ZM-188.49 314.698H-188.51V314.724H-188.49V314.698Z",
    fill: "url(#paint4_linear_7001_60015)",
    fillOpacity: 0.65
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1065.35 417.309H-378.052V436.678H1065.35V417.309Z",
    fill: "#CFCDC8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-376.293 423.471L1057.32 423.358",
    stroke: "white",
    strokeWidth: 0.624494,
    strokeDasharray: "3.12 3.12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.7496 407.669L88.8185 406.517C92.3797 406.291 95.3985 403.832 96.352 400.395L96.7732 398.862C96.9618 398.165 96.9787 397.434 96.8136 396.73L96.4261 395.062C95.5097 391.143 89.9775 391.029 88.8994 394.907L87.4911 392.201C85.5369 388.458 79.9273 389.442 79.3612 393.623C77.8586 388.138 70.2308 387.737 68.1621 393.037L68.0779 393.249L67.1311 392.242C64.456 389.385 59.8773 389.516 57.3639 392.521C55.1537 395.166 55.3794 399.075 57.8827 401.446L60.1906 403.63C57.7378 404.91 58.8126 408.633 61.572 408.411L70.7496 407.666V407.669Z",
    fill: "#FAEAC7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0576 404.289L38.4291 399.185C41.8488 398.181 44.2578 395.115 44.4263 391.554L44.5004 389.967C44.5341 389.246 44.3858 388.528 44.0725 387.878L43.3245 386.335C41.5692 382.717 36.1448 383.822 35.9494 387.841L33.9751 385.513C31.246 382.292 25.9935 384.485 26.3607 388.69C23.6856 383.67 16.1555 384.96 15.3064 390.587L15.2728 390.813L14.1272 390.038C10.8827 387.841 6.44889 388.976 4.66323 392.464C3.08982 395.529 4.17132 399.293 7.13619 401.055L9.86859 402.679C7.75949 404.468 9.62601 407.864 12.2674 407.039L21.0576 404.293V404.289Z",
    fill: "#FAEAC7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.558 400.488L141.745 395.845C138.884 394.339 137.149 391.324 137.28 388.096L137.408 385.078C137.439 384.296 137.664 383.538 138.065 382.864L139.13 381.058C141.357 377.291 147.139 378.996 146.96 383.369L149.43 380.873C152.657 377.611 158.159 380.458 157.361 384.976C160.74 379.707 168.89 381.83 169.274 388.079L170.635 387.291C174.358 385.135 179.126 386.759 180.76 390.738C182.165 394.164 180.692 398.096 177.387 399.76L174.031 401.455H154.456C153.095 401.455 151.758 401.125 150.555 400.492L150.558 400.488Z",
    fill: "#AACAC9",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.406 398.901L141.559 396.61C139.517 394.969 138.362 392.466 138.439 389.848L138.54 386.459C138.557 385.738 138.759 385.034 139.127 384.41L139.989 382.931C142.014 379.458 147.337 380.974 147.226 384.993L149.369 382.823C152.337 379.821 157.408 382.406 156.72 386.573C159.769 381.772 167.178 383.632 167.599 389.306L167.616 389.535L170.227 387.786C172.737 386.108 176.026 386.166 178.472 387.931L179.361 388.571C181.602 390.188 182.41 393.153 181.302 395.687C180.753 396.954 179.766 397.981 178.529 398.595L172.101 401.778H156.72L148.537 400.68C147.027 400.478 145.595 399.865 144.406 398.908V398.901Z",
    fill: "#6F9392"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.4843 384.113H46.7139V395.959H61.4843V384.113Z",
    fill: "#CDD9F4",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.5584 383.648H46.6396V383.942H61.5584V383.648Z",
    stroke: "#615E66",
    strokeWidth: 0.222366
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.9837 381.747L46.8887 383.529H61.3121L60.2172 381.747C60.0959 381.552 59.8836 381.434 59.6545 381.434H48.5463C48.3172 381.434 48.1049 381.552 47.9837 381.747Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.4843 391.912H46.7139V395.958H61.4843V391.912Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.2006 393.086H48.082V394.595H49.2006V393.086Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.7338 393.086H50.6152V394.595H51.7338V393.086Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.1957 393.086H56.0771V394.595H57.1957V393.086Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.9252 393.086H58.8066V394.595H59.9252V393.086Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.7331 388.014H59.002V390.888H59.7331V388.014Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.7331 384.891H59.002V386.205H59.7331V384.891Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.0035 388.014H56.4678V390.888H57.0035V388.014Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.0035 384.891H56.4678V386.205H57.0035V384.891Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.2711 388.014H53.7354V390.888H54.2711V388.014Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.2711 384.891H53.7354V386.205H54.2711V384.891Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.5426 388.014H51.0068V390.888H51.5426V388.014Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.5426 384.891H51.0068V386.205H51.5426V384.891Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.0054 388.014H48.4697V390.888H49.0054V388.014Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.0054 384.891H48.4697V386.205H49.0054V384.891Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.6577 393.086H53.5391V395.96H54.6577V393.086Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.852 378.791H191.736V395.96H234.852V378.791Z",
    fill: "#D8D0C3",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.852 390.836H191.736V395.957H234.852V390.836Z",
    fill: "#D8D0C3",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.543 382.268H193.825V384.377H194.543V382.268Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.234 379.963H190.359V380.657H236.234V379.963Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.544 387.133H193.826V389.242H194.544V387.133Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.776 391.996H192.667V395.958H194.776V391.996Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.338 391.996H197.07V395.958H200.338V391.996Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.436 391.996H202.168V395.958H205.436V391.996Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.534 391.996H207.266V395.958H210.534V391.996Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.895 392.704C211.895 391.929 212.525 391.303 213.299 391.303C214.074 391.303 214.698 391.929 214.698 392.704V395.959H211.895V392.704Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.337 391.996H216.069V395.958H219.337V391.996Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.435 391.996H221.167V395.958H224.435V391.996Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.762 391.996H226.494V395.958H229.762V391.996Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.7 391.996H231.823V395.958H233.7V391.996Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.482 382.268H197.765V384.377H198.482V382.268Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.482 387.133H197.765V389.242H198.482V387.133Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.032 382.268H200.314V384.377H201.032V382.268Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.032 387.133H200.314V389.242H201.032V387.133Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.58 382.268H202.862V384.377H203.58V382.268Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.58 387.133H202.862V389.242H203.58V387.133Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.894 382.268H205.177V384.377H205.894V382.268Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.894 387.133H205.177V389.242H205.894V387.133Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.678 382.268H207.96V384.377H208.678V382.268Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.678 387.133H207.96V389.242H208.678V387.133Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.991 382.268H210.273V384.377H210.991V382.268Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.991 387.133H210.273V389.242H210.991V387.133Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.774 382.268H213.057V384.377H213.774V382.268Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.774 387.133H213.057V389.242H213.774V387.133Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.555 382.268H215.837V384.377H216.555V382.268Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.555 387.133H215.837V389.242H216.555V387.133Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.101 382.268H218.384V384.377H219.101V382.268Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.101 387.133H218.384V389.242H219.101V387.133Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.416 382.268H220.698V384.377H221.416V382.268Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.417 387.133H220.699V389.242H221.417V387.133Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.2 382.268H223.482V384.377H224.2V382.268Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.2 387.133H223.482V389.242H224.2V387.133Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.75 382.268H226.032V384.377H226.75V382.268Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.75 387.133H226.032V389.242H226.75V387.133Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.064 382.268H228.347V384.377H229.064V382.268Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.064 387.133H228.347V389.242H229.064V387.133Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.77 382.268H232.053V384.377H232.77V382.268Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.77 387.133H232.053V389.242H232.77V387.133Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.554 378.791H191.047V379.974H235.554V378.791Z",
    fill: "#CDD9F4",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.684 378.791H82.5684V395.96H125.684V378.791Z",
    fill: "#CDD9F4",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.755 391.996H82.6162V395.958H125.755V391.996Z",
    fill: "#CDD9F4",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.3719 382.268H84.6543V384.377H85.3719V382.268Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.066 379.963H81.1914V380.657H127.066V379.963Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.755 387.154H82.6162V390.675H125.755V387.154Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.699 391.996H82.6162V395.958H85.699V391.996Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.755 391.996H82.6162V395.958H125.755V391.996Z",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.1666 391.996H87.8984V395.958H91.1666V391.996Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.1439 391.996H93.623V395.958H97.1439V391.996Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.362 391.996H98.0938V395.958H101.362V391.996Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.727 392.704C102.727 391.929 103.357 391.303 104.132 391.303C104.906 391.303 105.53 391.929 105.53 392.704V395.959H102.727V392.704Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.167 391.996H106.898V395.958H110.167V391.996Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.264 391.996H111.996V395.958H115.264V391.996Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.59 391.996H117.322V395.958H120.59V391.996Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.758 391.996H122.675V395.958H125.758V391.996Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.638 381.871H82.6162V385.833H126.638V381.871Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.638 381.871H82.6162V382.312H126.638V381.871Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.638 387.154H82.6162V387.596H126.638V387.154Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.638 391.996H82.6162V392.437H126.638V391.996Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.598 387.133H122.881V389.242H123.598V387.133Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.385 378.791H81.8779V380.412H126.385V378.791Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.638 378.791H82.6162V379.232H126.638V378.791Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.249 396.177H145.55C147.665 396.177 149.71 395.372 151.26 393.923L152.749 392.535C153.15 392.158 153.444 391.683 153.598 391.154L153.723 390.739C154.576 387.842 151.062 385.669 148.855 387.727V386.16C148.855 382.973 144.849 381.551 142.841 384.024C143.801 380.163 139.367 377.246 136.203 379.655L135.324 380.322L135.078 379.554C134.229 376.905 131.355 375.49 128.734 376.437C126.136 377.377 124.826 380.281 125.843 382.852L126.305 384.024C122.427 384.024 120.26 388.495 122.656 391.541L124.482 393.859C125.631 395.321 127.393 396.177 129.253 396.177H129.249Z",
    fill: "#E1F1F1",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.626 396.177H144.659C146.674 396.177 148.622 395.446 150.141 394.122L151.33 393.085C151.704 392.758 151.981 392.333 152.132 391.858C152.954 389.257 149.848 387.188 147.786 388.981V387.879C147.786 384.988 144.198 383.647 142.301 385.827C143.194 382.482 139.41 379.857 136.587 381.862L135.448 382.674L135.236 382.061C134.444 379.753 131.937 378.52 129.626 379.301C127.183 380.127 125.961 382.852 126.965 385.224L127.221 385.831C123.771 385.831 121.894 389.864 124.121 392.502L125.671 394.341C126.651 395.507 128.1 396.181 129.63 396.181L129.626 396.177Z",
    fill: "#AACAC9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.062 395.109C94.062 393.229 94.4494 391.372 95.1974 389.651L95.9487 387.926C97.4042 384.577 102.161 384.577 103.617 387.926L104.368 389.651C105.116 391.372 105.504 393.229 105.504 395.109C105.504 395.577 105.126 395.958 104.655 395.958H94.9076C94.4359 395.958 94.0586 395.577 94.0586 395.109H94.062Z",
    fill: "#E1F1F1",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.6045 394.893C95.6045 393.36 95.9246 391.844 96.5479 390.442L96.905 389.64C98.2695 386.568 102.629 386.568 103.994 389.64L104.351 390.442C104.971 391.844 105.294 393.36 105.294 394.893C105.294 395.358 104.917 395.739 104.449 395.739H96.4535C95.9852 395.739 95.6079 395.361 95.6079 394.893H95.6045Z",
    fill: "#AACAC9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.7852 392.656V396.177",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.646 391.777L99.7852 394.419",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.5859 393.098L99.786 395.52",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.046 396.176H113.774C114.907 396.176 115.991 395.748 116.82 394.977L117.413 394.421C117.612 394.239 117.753 394.01 117.828 393.754L117.885 393.565C118.299 392.167 116.605 391.112 115.533 392.106V391.358C115.533 389.818 113.596 389.128 112.622 390.324C113.087 388.464 110.954 387.052 109.421 388.211L108.987 388.542L108.872 388.174C108.458 386.897 107.073 386.213 105.81 386.668C104.55 387.123 103.916 388.528 104.412 389.771L104.631 390.324C102.761 390.324 101.713 392.483 102.875 393.952L103.751 395.064C104.307 395.765 105.149 396.176 106.046 396.176Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.59 395.958L105.948 391.777",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.71 394.196L109.25 390.895",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.332 396.177L114.532 393.316",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.111 392.656L113.651 394.196",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.789 395.957L106.386 388.693",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1065.35 409.826H-378.052V414.23H1065.35V409.826Z",
    fill: "#FFF9DE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-1.01988 387.374C21.9545 387.374 40.5793 368.749 40.5793 345.775C40.5793 322.801 21.9545 304.176 -1.01988 304.176C-23.9943 304.176 -42.6191 322.801 -42.6191 345.775C-42.6191 368.749 -23.9943 387.374 -1.01988 387.374ZM-1.01988 383.853C20.0105 383.853 37.0585 366.805 37.0585 345.775C37.0585 324.745 20.0105 307.697 -1.01988 307.697C-22.0503 307.697 -39.0983 324.745 -39.0983 345.775C-39.0983 366.805 -22.0503 383.853 -1.01988 383.853Z",
    fill: "#CDD9F4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-1.02111 368.006C11.2562 368.006 21.2087 358.151 21.2087 345.995C21.2087 333.839 11.2562 323.984 -1.02111 323.984C-13.2984 323.984 -23.251 333.839 -23.251 345.995C-23.251 358.151 -13.2984 368.006 -1.02111 368.006ZM-1.02111 364.927C9.55474 364.927 18.1293 356.453 18.1293 345.999C18.1293 335.544 9.55474 327.071 -1.02111 327.071C-11.597 327.071 -20.1715 335.544 -20.1715 345.999C-20.1715 356.453 -11.597 364.927 -1.02111 364.927Z",
    fill: "#CDD9F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1.01988 387.374C21.9547 387.374 40.5793 368.75 40.5793 345.775C40.5793 322.8 21.9547 304.176 -1.01988 304.176C-23.9945 304.176 -42.6191 322.8 -42.6191 345.775C-42.6191 368.75 -23.9945 387.374 -1.01988 387.374Z",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1.02018 383.854C20.01 383.854 37.0582 366.806 37.0582 345.776C37.0582 324.746 20.01 307.697 -1.02018 307.697C-22.0503 307.697 -39.0986 324.746 -39.0986 345.776C-39.0986 366.806 -22.0503 383.854 -1.02018 383.854Z",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1.02036 379.451C17.5778 379.451 32.6546 364.472 32.6546 345.995C32.6546 327.518 17.5778 312.539 -1.02036 312.539C-19.6185 312.539 -34.6953 327.518 -34.6953 345.995C-34.6953 364.472 -19.6185 379.451 -1.02036 379.451Z",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1.02105 375.05C14.9032 375.05 27.8124 362.043 27.8124 345.998C27.8124 329.953 14.9032 316.945 -1.02105 316.945C-16.9453 316.945 -29.8545 329.953 -29.8545 345.998C-29.8545 362.043 -16.9453 375.05 -1.02105 375.05Z",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1.02136 371.53C12.9584 371.53 24.2913 360.099 24.2913 345.998C24.2913 331.898 12.9584 320.467 -1.02136 320.467C-15.0011 320.467 -26.334 331.898 -26.334 345.998C-26.334 360.099 -15.0011 371.53 -1.02136 371.53Z",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1.02111 368.01C11.2561 368.01 21.2087 358.155 21.2087 345.999C21.2087 333.843 11.2561 323.988 -1.02111 323.988C-13.2983 323.988 -23.251 333.843 -23.251 345.999C-23.251 358.155 -13.2983 368.01 -1.02111 368.01Z",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1.01949 364.926C9.55698 364.926 18.1309 356.452 18.1309 345.998C18.1309 335.545 9.55698 327.07 -1.01949 327.07C-11.596 327.07 -20.1699 335.545 -20.1699 345.998C-20.1699 356.452 -11.596 364.926 -1.01949 364.926Z",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1.0205 357.884C5.66516 357.884 11.0849 352.562 11.0849 345.998C11.0849 339.433 5.66516 334.111 -1.0205 334.111C-7.70616 334.111 -13.126 339.433 -13.126 345.998C-13.126 352.562 -7.70616 357.884 -1.0205 357.884Z",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.73 390.235H22.5299C22.001 389.356 22.3109 388.254 22.5299 387.812H24.73C25.259 388.87 24.949 389.868 24.73 390.235Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.606 392.876H12.4059C11.8769 391.996 12.1869 390.894 12.4059 390.453H14.606C15.135 391.511 14.825 392.508 14.606 392.876Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.36088 394.637H3.16079C2.63183 393.758 2.9418 392.656 3.16079 392.215H5.36088C5.88984 393.273 5.57987 394.27 5.36088 394.637Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.6548 384.512H30.4547C29.9258 383.633 30.2357 382.531 30.4547 382.09H32.6548C33.1838 383.148 32.8738 384.145 32.6548 384.512Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.6958 376.59H37.4958C36.9668 375.711 37.2768 374.609 37.4958 374.168H39.6958C40.2248 375.226 39.9148 376.223 39.6958 376.59Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.5406 367.786H42.3405C41.8115 366.906 42.1215 365.805 42.3405 365.363H44.5406C45.0695 366.421 44.7596 367.418 44.5406 367.786Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.062 358.102H45.862C45.333 357.223 45.643 356.121 45.862 355.68H48.062C48.591 356.738 48.281 357.735 48.062 358.102Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.9409 347.977H46.7409C46.2119 347.098 46.5219 345.996 46.7409 345.555H48.9409C49.4699 346.613 49.1599 347.61 48.9409 347.977Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.6206 337.852H45.4206C44.8916 336.973 45.2016 335.871 45.4206 335.43H47.6206C48.1496 336.488 47.8396 337.485 47.6206 337.852Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.1001 328.169H41.9001C41.3711 327.289 41.6811 326.187 41.9001 325.746H44.1001C44.6291 326.804 44.3191 327.801 44.1001 328.169Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.2583 318.922H37.0583C36.5293 318.043 36.8393 316.941 37.0583 316.5H39.2583C39.7873 317.558 39.4773 318.555 39.2583 318.922Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.2134 311.881H30.0133C29.4844 311.002 29.7943 309.9 30.0133 309.459H32.2134C32.7424 310.517 32.4324 311.514 32.2134 311.881Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.8511 305.719H21.651C21.1221 304.84 21.432 303.738 21.651 303.297H23.8511C24.3801 304.355 24.0701 305.352 23.8511 305.719Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.606 302.194H12.4059C11.8769 301.315 12.1869 300.213 12.4059 299.771H14.606C15.135 300.829 14.825 301.827 14.606 302.194Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.48197 299.997H2.28189C1.75293 299.117 2.06289 298.016 2.28189 297.574H4.48197C5.01093 298.632 4.70097 299.629 4.48197 299.997Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.15963 299.994L-1.02148 344.895",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6237 302.195L-1.02148 345.557",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6497 305.719L-1.02148 345.778",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.793 310.996L-1.02148 345.773",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.8346 317.824L-1.02148 345.778",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.6776 326.188L-0.582031 345.776",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.421 335.434L-0.800781 345.777",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.62 345.555L-1.24316 345.996",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.741 355.679L-0.579102 345.996",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.4382 365.145L-1.02148 345.994",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.5979 374.169L-1.23926 345.777",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.7754 382.092L-0.797852 345.994",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6281 387.816L-1.24316 345.775",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7266 390.235L-1.23926 345.775",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.48107 391.995L-1.24316 345.555",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.34199 305.059L6.68164 308.36",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7077 307.699L14.168 310.782",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.191 312.1L21.21 314.741",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.5721 317.604L26.9307 320.026",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.8546 324.867L31.9941 326.407",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.3758 332.572L35.293 333.674",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.3567 341.152L36.8359 341.594",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.3565 349.957L37.0547 349.516",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.8174 358.102L35.5156 357.223",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.0763 366.022L32.2158 364.26",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.0123 373.067L27.5898 371.086",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6276 379.013L21.6465 376.371",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9262 383.411L14.6055 380.551",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.00293 382.973L8.88232 386.055",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-5.20117 298.893L1.40241 304.175",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-4.54102 304.396L2.06256 298.895",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2028 305.721L4.91992 299.336",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.2627 304.398L12.187 299.994",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8252 301.758L18.5684 309.022",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.625 306.38L21.2097 304.398",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6289 305.719L25.61 313.862",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5498 309.9L30.0139 309.459",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5908 315.621L37.0549 316.5",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.5527 319.805V311.881",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.3145 322.225L42.7785 325.526",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.3945 327.507L37.4963 318.922",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.2773 329.27L46.5224 335.432",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.4775 335.874L42.5603 328.172",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.6963 337.412L47.3982 345.555",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.4216 337.633L40.5801 344.455",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.5791 346.877L46.7413 355.462",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.9189 353.258L46.5225 347.314",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.6963 355.238L43.4394 365.144",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.4961 361.404L45.6394 356.34",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.8359 363.383L38.598 373.949",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.5342 369.107L42.1188 366.246",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.2131 370.867L31.9941 381.871",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.4952 374.387L27.5898 375.926",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.2704 377.248L24.0703 387.814",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9902 380.994L30.4542 382.096",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5299 387.817L12.1865 385.617",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.2287 381.871L14.8252 390.675",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.7682 397.06L-0.359908 344.457L-1.23926 347.317L17.6888 397.06H20.7716H20.7682Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1.24292 349.959C0.945313 349.959 2.71923 348.186 2.71923 345.997C2.71923 343.809 0.945313 342.035 -1.24292 342.035C-3.43116 342.035 -5.20508 343.809 -5.20508 345.997C-5.20508 348.186 -3.43116 349.959 -1.24292 349.959Z",
    fill: "#705895",
    stroke: "#705895",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-3.21973 387.373L2.94251 392.215",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.9417 387.373L-4.32227 392.437",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.1416 386.938L12.1832 390.681",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.644 385.834L5.58008 392.219",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.595 355.899L56.8652 382.091V384.291L79.5364 379.887L170.659 361.397L175.942 363.159L154.814 376.366L144.248 385.611C149.972 382.751 162.428 376.633 166.478 375.046C171.542 373.065 192.01 363.159 194.87 361.839C200.372 359.298 198.613 355.895 194.87 355.235C185.009 353.122 171.245 354.794 165.595 355.895V355.899Z",
    fill: "#FAEAC7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.5554 396.177H70.7328L72.2826 390.621C72.8318 388.657 71.3527 386.713 69.3144 386.713H56.8652V384.291L168.041 362.054C171.687 361.326 175.383 360.878 179.099 360.72C180.406 360.666 180.942 362.374 179.837 363.075L144.157 385.763C142.267 386.963 141.448 389.301 142.173 391.417L143.8 396.174H138.298V389.786C138.298 388.846 137.341 388.206 136.472 388.566L131.917 390.453V386.71L156.788 369.322C157.708 368.819 157.102 367.293 156.087 367.559C137.904 372.31 109.37 378.428 100.442 380.548C92.3123 382.478 84.3712 384.577 79.7217 386.066C77.8855 386.653 76.7973 388.455 76.9826 390.372L77.552 396.174L77.5554 396.177Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.336918,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.7324 381.43V387.154",
    stroke: "#615E66",
    strokeWidth: 0.336918,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.2344 380.551V386.053",
    stroke: "#615E66",
    strokeWidth: 0.336918,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.7598 377.691V382.755",
    stroke: "#615E66",
    strokeWidth: 0.336918,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.8574 379.449V385.392",
    stroke: "#615E66",
    strokeWidth: 0.336918,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.4805 378.57V384.072",
    stroke: "#615E66",
    strokeWidth: 0.336918,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.9521 387.155L81.2955 385.174",
    stroke: "#615E66",
    strokeWidth: 0.336918,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.623 396.178V390.15C139.623 388.813 140.226 387.549 141.277 386.721C143.588 384.898 146.624 382.543 149.481 380.37C151.28 378.924 153.46 377.297 156.084 375.481C156.445 375.228 156.762 375.009 157.041 374.824C161.977 371.465 168.375 367.499 176.599 362.938C166.478 368.551 160.36 372.617 157.045 374.821H157.041C156.714 375.046 156.398 375.262 156.084 375.478C154.457 376.623 152.038 378.422 149.481 380.366C144.572 384.301 142.5 386.862 142.042 388.028V396.171H139.619L139.623 396.178Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.9448 389.502L73.5938 395.958H77.5559C77.411 395.371 77.4683 393.491 77.1145 390.675C76.7608 387.858 78.2904 386.713 79.3146 386.494L96.9219 381.43L78.5667 385.783C76.7406 386.217 75.3255 387.666 74.9448 389.502Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.921 388.253L168.237 367.125L176.822 362.943",
    stroke: "#615E66",
    strokeWidth: 0.336918,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.595 355.901L56.8652 382.093V380.772L165.595 352.818C171.98 351.571 186.771 349.826 194.87 352.818C198.04 353.876 199.638 354.873 200.153 355.24C200.153 357.002 200.372 358.984 199.274 359.863C198.394 360.567 162.223 377.325 144.248 385.614C149.972 382.753 162.428 376.635 166.478 375.048C171.542 373.067 192.01 363.161 194.87 361.841C200.372 359.3 198.613 355.897 194.87 355.237C185.009 353.125 171.245 354.796 165.595 355.897V355.901Z",
    fill: "#FBDC99",
    stroke: "#615E66",
    strokeWidth: 0.336918,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.8652 378.571V380.771L87.8987 372.847C112.473 366.024 164.847 352.157 177.701 351.278C190.554 350.398 198.024 353.552 200.15 355.24V350.897C200.15 349.852 199.853 348.805 199.041 348.154C196.946 346.487 192.899 344.853 189.146 344.674C177.526 343.616 164.349 346.581 159.211 348.195L56.8652 378.568V378.571Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.336918,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.8652 381.871V384.294",
    stroke: "#615E66",
    strokeWidth: 0.336918,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.132 367.566L176.6 362.943",
    stroke: "#615E66",
    strokeWidth: 0.336918,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.901 354.359L176.818 360.744",
    stroke: "#615E66",
    strokeWidth: 0.336918,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.995 355.238L174.618 360.963",
    stroke: "#615E66",
    strokeWidth: 0.336918,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.147 354.359L178.581 360.744",
    stroke: "#615E66",
    strokeWidth: 0.336918,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.279 354.578V360.963",
    stroke: "#615E66",
    strokeWidth: 0.336918,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.045 378.57H232.066V396.178H361.045V378.57Z",
    fill: "#D8D0C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.189 329.486L364.785 352.596L373.147 353.256L369.185 329.486H369.189Z",
    fill: "#B7594C",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.189 329.486L367.649 353.256H373.151L369.189 329.486Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.988 353.258C366.988 352.53 367.578 351.938 368.309 351.938C369.04 351.938 369.63 352.527 369.63 353.258V360.522H366.988V353.258Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.785 353.039C364.785 352.433 365.277 351.938 365.887 351.938C366.497 351.938 366.989 352.429 366.989 353.039V360.522H364.789V353.039H364.785Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.63 353.7C369.63 352.726 370.418 351.938 371.392 351.938C372.366 351.938 373.154 352.726 373.154 353.7V360.522H369.633V353.7H369.63Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.309 359.642C368.309 358.062 369.589 356.781 371.169 356.781C372.75 356.781 374.03 358.062 374.03 359.642V364.483H368.306V359.642H368.309Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.905 359.423C363.905 358.206 364.892 357.223 366.105 357.223C367.318 357.223 368.305 358.21 368.305 359.423V366.687H363.901V359.423H363.905Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.63 360.414C369.63 359.623 370.273 358.982 371.062 358.982H371.281C372.069 358.982 372.713 359.623 372.713 360.414C372.713 361.206 372.069 361.846 371.281 361.846H371.062C370.273 361.846 369.63 361.206 369.63 360.414Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.227 360.743C365.227 360.257 365.624 359.863 366.106 359.863C366.588 359.863 366.985 360.257 366.985 360.743V361.403C366.985 361.888 366.588 362.282 366.106 362.282C365.624 362.282 365.227 361.888 365.227 361.403V360.743Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.887 370.87L372.709 362.285L387.898 370.87H365.887Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.709 362.285L359.502 368.889L359.943 369.33V373.292L365.887 371.092L372.709 362.289V362.285Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.675 396.618V370.867H366.106L359.943 373.29V396.621H387.675V396.618Z",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.943 378.791H233.164V396.398H359.943V378.791Z",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.165 371.307V378.79H359.944V369.107H231.43L233.114 371.169L233.161 371.23V371.307H233.165Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.133 304.836H293.254C292.889 304.836 292.594 305.132 292.594 305.496V370.205C292.594 370.569 292.889 370.865 293.254 370.865H294.133C294.498 370.865 294.794 370.569 294.794 370.205V305.496C294.794 305.132 294.498 304.836 294.133 304.836Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.417 304.836H298.537C298.173 304.836 297.877 305.132 297.877 305.496V370.205C297.877 370.569 298.173 370.865 298.537 370.865H299.417C299.781 370.865 300.077 370.569 300.077 370.205V305.496C300.077 305.132 299.781 304.836 299.417 304.836Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.209 384.957H234.047V396.402H240.209V384.957Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.209 384.957H234.047V387.157H240.209V384.957Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.368 380.109H234.047V383.192H235.368V380.109Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.009 380.109H236.247V383.192H238.009V380.109Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.209 380.109H238.889V383.192H240.209V380.109Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.334 384.957H244.172V396.402H250.334V384.957Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.493 380.109H244.172V383.192H245.493V380.109Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.134 380.109H246.372V383.192H248.134V380.109Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.334 380.109H249.014V383.192H250.334V380.109Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.703 384.957H263.541V396.402H269.703V384.957Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.862 380.109H263.541V383.192H264.862V380.109Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.503 380.109H265.741V383.192H267.503V380.109Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.704 380.109H268.383V383.192H269.704V380.109Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.828 384.957H273.666V396.402H279.828V384.957Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.986 380.109H273.665V383.192H274.986V380.109Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.627 380.109H275.865V383.192H277.627V380.109Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.828 380.109H278.507V383.192H279.828V380.109Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.951 384.957H283.789V396.402H289.951V384.957Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.111 380.109H283.79V383.192H285.111V380.109Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.751 380.109H285.989V383.192H287.751V380.109Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.952 380.109H288.631V383.192H289.952V380.109Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.759 384.957H303.597V396.402H309.759V384.957Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.917 380.109H303.597V383.192H304.917V380.109Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.562 380.109H305.8V383.192H307.562V380.109Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.759 380.109H308.438V383.192H309.759V380.109Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.884 384.957H313.722V396.402H319.884V384.957Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.042 380.109H313.722V383.192H315.042V380.109Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.687 380.109H315.925V383.192H317.687V380.109Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.887 380.109H318.566V383.192H319.887V380.109Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.064 384.957H352.901V396.402H359.064V384.957Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.222 380.109H352.901V383.192H354.222V380.109Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.865 380.109H355.103V383.192H356.865V380.109Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.829 388.477H369.188V396.401H371.829V388.477Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.227 388.914H363.906V393.756H365.227V388.914Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.584 388.914H361.264V393.756H362.584V388.914Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.905 386.712H365.226V381.49L363.905 381.82V386.712Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.264 386.713H362.584V381.932L361.264 382.262V386.713Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.905 374.781V378.103L365.226 377.938V374.451L363.905 374.781Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.264 375.221V378.543L362.584 378.378V374.891L361.264 375.221Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.064 380.109H357.743V383.192H359.064V380.109Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.939 384.957H342.777V396.402H348.939V384.957Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.098 380.109H342.777V383.192H344.098V380.109Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.739 380.109H344.977V383.192H346.739V380.109Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.94 380.109H347.619V383.192H348.94V380.109Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.008 384.957H323.846V396.402H330.008V384.957Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.166 380.109H323.846V383.192H325.166V380.109Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.811 380.109H326.049V383.192H327.811V380.109Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.011 380.109H328.69V383.192H330.011V380.109Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.019 377.029H349.819V396.399H352.019V377.029Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.967 377.029H320.767V396.399H322.967V377.029Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.842 377.029H310.642V396.399H312.842V377.029Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.907 377.029H280.707V396.399H282.907V377.029Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.783 377.029H270.583V396.399H272.783V377.029Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.289 377.029H241.089V396.399H243.289V377.029Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.654 379.01C251.654 375.971 254.121 373.508 257.156 373.508C260.192 373.508 262.658 375.971 262.658 379.01V396.398H251.654V379.01Z",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.891 379.01C330.891 375.971 333.357 373.508 336.392 373.508C339.428 373.508 341.894 375.971 341.894 379.01V396.398H330.891V379.01Z",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.106 369.547C366.106 369.062 366.503 368.668 366.985 368.668C367.467 368.668 367.865 369.062 367.865 369.547V396.619H366.103V369.547H366.106Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.63 374.829C369.63 374.343 370.028 373.949 370.51 373.949C370.991 373.949 371.389 374.343 371.389 374.829V377.689H369.627V374.829H369.63Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.188 381.872C369.188 381.144 369.777 380.551 370.508 380.551C371.239 380.551 371.829 381.14 371.829 381.872V386.053H369.188V381.872Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.272 376.809C291.272 373.77 293.739 371.307 296.774 371.307C299.81 371.307 302.276 373.77 302.276 376.809V396.397H291.272V376.809Z",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.164 396.401V376.371L227.882 375.27H207.633V396.398H233.164V396.401Z",
    fill: "#D8D0C3",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.734 375.269L222.821 365.363L228.104 375.269H208.734Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.884 375.05L223.043 365.586L231.405 369.329L233.167 371.31V376.593L227.884 375.053V375.05Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.157 392.878H213.799V385.836C213.799 385.109 213.209 384.516 212.478 384.516C211.747 384.516 211.157 385.105 211.157 385.836V392.878Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.596 381.433H213.358V379.233C213.358 378.748 212.96 378.354 212.478 378.354C211.997 378.354 211.599 378.748 211.599 379.233V381.433H211.596Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.04 381.433H224.802V379.233C224.802 378.748 224.405 378.354 223.923 378.354C223.441 378.354 223.043 378.748 223.043 379.233V381.433H223.04Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.602 392.878H225.243V385.836C225.243 385.109 224.653 384.516 223.922 384.516C223.191 384.516 222.602 385.105 222.602 385.836V392.878Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.557 375.048C215.557 373.468 216.837 372.188 218.418 372.188C219.998 372.188 221.278 373.468 221.278 375.048V396.398H215.554V375.048H215.557Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.633 373.289C207.633 372.683 208.125 372.188 208.735 372.188C209.344 372.188 209.836 372.679 209.836 373.289V396.398H207.636V373.289H207.633Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.564 373.067C226.564 372.582 226.961 372.188 227.443 372.188C227.925 372.188 228.323 372.582 228.323 373.067V396.398H226.561V373.067H226.564Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.318 381.433H219.08V379.233C219.08 378.748 218.683 378.354 218.201 378.354C217.719 378.354 217.322 378.748 217.322 379.233V381.433H217.318Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.878 392.878H219.961V386.055C219.961 385.203 219.27 384.516 218.421 384.516C217.572 384.516 216.881 385.206 216.881 386.055V392.878H216.878Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.533 379.449C252.533 376.895 254.602 374.826 257.156 374.826C259.71 374.826 261.778 376.895 261.778 379.449V396.396H252.533V379.449Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.855 396.402H260.017V388.04C260.017 386.338 258.639 384.957 256.934 384.957C255.23 384.957 253.852 386.335 253.852 388.04V396.402H253.855Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.175 380.109H253.854V383.192H255.175V380.109Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.817 380.109H256.055V383.192H257.817V380.109Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.017 380.109H258.696V383.192H260.017V380.109Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.771 379.449C331.771 376.895 333.839 374.826 336.393 374.826C338.947 374.826 341.016 376.895 341.016 379.449V396.396H331.771V379.449Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.152 377.249C292.152 374.696 294.221 372.627 296.775 372.627C299.329 372.627 301.397 374.696 301.397 377.249V396.4H292.152V377.249Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.472 396.402H299.634V388.04C299.634 386.338 298.256 384.957 296.552 384.957C294.847 384.957 293.469 386.335 293.469 388.04V396.402H293.472Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.793 380.109H293.473V383.192H294.793V380.109Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.436 380.109H295.674V383.192H297.436V380.109Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.635 380.109H298.314V383.192H299.635V380.109Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.09 396.402H339.252V388.04C339.252 386.338 337.874 384.957 336.17 384.957C334.465 384.957 333.087 386.335 333.087 388.04V396.402H333.09Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.09 396.401H339.252V389.798C339.252 388.096 337.874 386.715 336.17 386.715C334.465 386.715 333.087 388.093 333.087 389.798V396.401H333.09Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.473 396.401H299.635V389.798C299.635 388.096 298.257 386.715 296.552 386.715C294.848 386.715 293.47 388.093 293.47 389.798V396.401H293.473Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.855 396.401H260.017V389.798C260.017 388.096 258.639 386.715 256.934 386.715C255.23 386.715 253.852 388.093 253.852 389.798V396.401H253.855Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.412 380.109H333.091V383.192H334.412V380.109Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.053 380.109H335.291V383.192H337.053V380.109Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.252 380.109H337.932V383.192H339.252V380.109Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.151 371.529C373.151 369.218 375.021 367.348 377.332 367.348C379.644 367.348 381.514 369.221 381.514 371.529V396.619H373.151V371.529Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.91 374.829C374.91 374.343 375.307 373.949 375.789 373.949C376.271 373.949 376.668 374.343 376.668 374.829V377.689H374.906V374.829H374.91Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.334 384.957H244.172V387.157H250.334V384.957Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.703 384.957H263.541V387.157H269.703V384.957Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.828 384.957H273.666V387.157H279.828V384.957Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.951 384.957H283.789V387.157H289.951V384.957Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.759 384.957H303.597V387.157H309.759V384.957Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.884 384.957H313.722V387.157H319.884V384.957Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.008 384.957H323.846V387.157H330.008V384.957Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.939 384.957H342.777V387.157H348.939V384.957Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.064 384.957H352.901V387.157H359.064V384.957Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.4807 390.005C46.9868 388.422 47.2867 386.043 46.2186 384.136L40.1608 373.291C39.5712 372.236 38.0585 372.236 37.4689 373.291L31.2325 384.456C30.2622 386.195 30.4711 388.358 31.7648 389.877C32.6711 390.945 34.002 391.559 35.4036 391.559H41.8623C43.2301 391.559 44.5374 390.996 45.4807 390.005Z",
    fill: "#E1F1F1",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.1172 390.227C46.5693 388.873 46.8557 386.676 45.7944 384.995L40.744 376.979C40.0534 375.884 38.453 375.884 37.7623 376.979L31.9943 386.137C31.344 387.168 31.4822 388.509 32.3245 389.391C33.5205 390.638 35.1714 391.342 36.8964 391.342H42.2871C43.3349 391.342 44.3457 390.945 45.1105 390.23L45.1172 390.227Z",
    fill: "#62AE80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.8164 380.336V396.623",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.5146 381.656L38.5975 384.739",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.1179 385.178L39.0352 388.261",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.6775 381.656L38.5947 384.739",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.4942 396.375C57.5392 394.532 57.2495 391.243 54.9113 389.788L51.0334 387.376C50.4337 387.005 49.6722 387.018 49.0927 387.416L45.6528 389.764C43.4257 391.287 43.1293 394.458 45.0362 396.365C45.0598 396.388 45.0935 396.402 45.1272 396.402H55.42C55.447 396.402 55.4773 396.392 55.4975 396.371L55.4942 396.375Z",
    fill: "#FFD6D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.4975 396.371C55.4773 396.392 55.447 396.402 55.42 396.402H45.1272C45.0935 396.402 45.0598 396.388 45.0362 396.365C43.1293 394.458 43.4257 391.287 45.6528 389.764L49.0927 387.416C49.6722 387.018 50.4337 387.005 51.0334 387.376L54.9113 389.788C57.2495 391.243 57.5392 394.532 55.4942 396.375L55.4975 396.371ZM55.4975 396.371L55.6458 396.536",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.0641 396.089C57.4051 394.482 56.9738 392.056 55.1646 391.005L50.8217 388.488C50.3433 388.212 49.7503 388.218 49.2752 388.505L46.3003 390.321C44.1844 391.611 44.0362 394.626 46.0105 396.122C46.0577 396.159 46.115 396.176 46.1756 396.176H55.8687C55.9462 396.176 56.0203 396.143 56.0675 396.082L56.0641 396.089Z",
    fill: "#E9A59B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.7031 392.66V396.181",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.8428 391.781L50.7032 394.423",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.9022 393.102L50.7021 395.524",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1065.35 395.961H-377.832V409.606H1065.35V395.961Z",
    fill: "#E1F1F1",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1065.35 398.82H-378.052V409.386H1065.35V398.82Z",
    fill: "#A9D395"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-377.3 409.386H-78.8446L-178.33 406.303H-296.743L-377.3 409.386Z",
    fill: "#62AE80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-172.478 409.386H176.602L91.6452 406.303H-26.7678L-172.475 409.386H-172.478Z",
    fill: "#62AE80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.699 409.386H666.984L524.798 406.303H247.912L131.699 409.386Z",
    fill: "#62AE80"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.32,
    d: "M230.833 413.274C227.956 412.314 225.766 413.675 225.035 414.474C224.765 414.605 224.193 414.753 224.034 414.275C225.631 412.476 228.832 411.876 230.83 413.274H230.833Z",
    fill: "url(#paint5_linear_7001_60015)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.129 402.591C329.129 400.711 329.517 398.855 330.265 397.133L331.016 395.408C332.472 392.059 337.229 392.059 338.684 395.408L339.436 397.133C340.184 398.855 340.571 400.711 340.571 402.591C340.571 403.06 340.194 403.44 339.722 403.44H329.975C329.503 403.44 329.126 403.06 329.126 402.591H329.129Z",
    fill: "#E1F1F1",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.672 402.375C330.672 400.842 330.992 399.326 331.615 397.925L331.972 397.123C333.337 394.05 337.697 394.05 339.061 397.123L339.418 397.925C340.038 399.326 340.362 400.842 340.362 402.375C340.362 402.84 339.984 403.221 339.516 403.221H331.521C331.053 403.221 330.675 402.844 330.675 402.375H330.672Z",
    fill: "#AACAC9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.854 400.139V403.659",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.714 399.26L334.854 401.901",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.653 400.58L334.853 403.003",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.908 403.41C297.86 401.567 298.153 398.279 300.488 396.823L304.366 394.411C304.965 394.04 305.727 394.054 306.306 394.451L309.75 396.8C311.977 398.322 312.273 401.493 310.366 403.4C310.339 403.423 310.309 403.437 310.275 403.437H299.982C299.955 403.437 299.929 403.427 299.908 403.406V403.41Z",
    fill: "#FFD6D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.908 403.406C299.929 403.427 299.955 403.437 299.982 403.437H310.275C310.309 403.437 310.339 403.423 310.366 403.4C312.273 401.493 311.977 398.322 309.75 396.8L306.306 394.451C305.727 394.054 304.965 394.04 304.366 394.411L300.488 396.823C298.153 398.279 297.86 401.567 299.908 403.41V403.406ZM299.908 403.406L299.76 403.572",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.218 403.128C298.88 401.521 299.311 399.095 301.121 398.044L305.46 395.527C305.939 395.251 306.535 395.257 307.007 395.544L309.982 397.36C312.097 398.65 312.249 401.666 310.271 403.161C310.228 403.199 310.17 403.215 310.11 403.215H300.42C300.339 403.215 300.272 403.182 300.218 403.121V403.128Z",
    fill: "#E9A59B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.699 399.701V403.222",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.56 398.816L304.699 401.458",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.499 400.139L304.699 402.561",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.113 403.66H348.842C349.974 403.66 351.059 403.233 351.888 402.461L352.481 401.905C352.679 401.723 352.821 401.494 352.895 401.238L352.952 401.049C353.367 399.651 351.672 398.597 350.601 399.591V398.843C350.601 397.303 348.663 396.612 347.69 397.808C348.155 395.948 346.022 394.537 344.489 395.696L344.054 396.026L343.94 395.659C343.525 394.382 342.141 393.698 340.877 394.153C339.617 394.608 338.984 396.012 339.479 397.256L339.698 397.808C337.828 397.808 336.78 399.968 337.943 401.437L338.819 402.549C339.375 403.249 340.217 403.66 341.113 403.66Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.657 403.441L341.016 399.26",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.777 401.679L344.317 398.377",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.397 403.659L349.598 400.799",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.178 400.139L348.717 401.678",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.857 403.44L341.453 396.176",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.758 393.977C276.061 393.977 276.31 394.223 276.31 394.529V403.363C276.31 403.666 276.064 403.916 275.758 403.916C275.454 403.916 275.205 403.67 275.205 403.363V394.529C275.205 394.226 275.451 393.977 275.758 393.977Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.08 394.711H276.311V398.39H295.08V394.711Z",
    fill: "#FFF9DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.08 397.287H276.311V397.654H295.08V397.287Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.08 395.816H276.311V396.184H295.08V395.816Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.975 394.529C293.975 394.223 294.221 393.977 294.524 393.977C294.827 393.977 295.08 394.223 295.08 394.529V403.363C295.08 403.666 294.834 403.916 294.524 403.916C294.214 403.916 293.975 403.67 293.975 403.363V394.529Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.701 400.232C279.004 400.232 279.254 400.478 279.254 400.785V404.097C279.254 404.4 279.008 404.649 278.701 404.649C278.398 404.649 278.148 404.403 278.148 404.097V400.785C278.148 400.482 278.394 400.232 278.701 400.232Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.101 400.232C297.405 400.232 297.654 400.478 297.654 400.785V404.097C297.654 404.4 297.408 404.649 297.101 404.649C296.798 404.649 296.549 404.403 296.549 404.097V400.785C296.549 400.482 296.795 400.232 297.101 400.232Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.31 400.232L275.205 399.312H295.08L297.654 400.232V401.337H278.15L276.31 400.232Z",
    fill: "#FFF9DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.656 400.232H278.148V401.338H297.656V400.232Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.205 399.312L278.15 400.232V401.705L275.205 400.418V399.312Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1065.35 435.797H-378.052V441.036H1065.35V435.797Z",
    fill: "#C3E1B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1065.35 440.566H-378.052V444.157H1065.35V440.566Z",
    fill: "#FFF9DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.3595 399.262C86.2315 400.023 85.5711 400.582 84.7996 400.582H82.7478C81.9291 400.582 81.2114 400.043 80.9823 399.262C80.7768 400.04 80.076 400.582 79.2708 400.582H77.5154C76.6967 400.582 75.9791 400.043 75.75 399.262C75.5175 400.047 74.7931 400.582 73.9744 400.582H72.0843C71.2656 400.582 70.548 400.043 70.3189 399.262C70.0359 400.053 69.2845 400.582 68.449 400.582H66.9867C66.2556 400.582 65.666 399.993 65.666 399.262",
    stroke: "#615E66",
    strokeWidth: 0.336918,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.1409 403.225C51.0162 404.475 49.965 405.425 48.7083 405.425H48.3882C47.0945 405.425 45.9894 404.498 45.767 403.225C45.5683 404.491 44.453 405.425 43.1694 405.425C41.879 405.425 40.7537 404.495 40.5313 403.225C40.3022 404.498 39.1937 405.425 37.9 405.425H37.7282C36.4344 405.425 35.3293 404.498 35.107 403.225L35.0261 403.599C34.797 404.667 33.857 405.428 32.7654 405.428H32.6542C31.4379 405.428 30.4541 404.441 30.4541 403.228",
    stroke: "#615E66",
    strokeWidth: 0.336918,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.138 399.262C213.01 400.023 212.349 400.582 211.578 400.582H209.526C208.707 400.582 207.99 400.043 207.761 399.262C207.555 400.04 206.854 400.582 206.049 400.582H204.294C203.475 400.582 202.757 400.043 202.528 399.262C202.296 400.047 201.571 400.582 200.753 400.582H198.863C198.044 400.582 197.326 400.043 197.097 399.262C196.814 400.053 196.063 400.582 195.227 400.582H193.765C193.034 400.582 192.444 399.993 192.444 399.262",
    stroke: "#615E66",
    strokeWidth: 0.336918,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.919 403.225C177.794 404.475 176.743 405.425 175.49 405.425H175.17C173.876 405.425 172.771 404.498 172.545 403.225C172.343 404.491 171.235 405.425 169.948 405.425C168.657 405.425 167.535 404.495 167.31 403.225C167.08 404.498 165.972 405.425 164.678 405.425H164.506C163.213 405.425 162.108 404.498 161.882 403.225L161.801 403.599C161.572 404.667 160.628 405.428 159.537 405.428H159.426C158.209 405.428 157.226 404.441 157.226 403.228",
    stroke: "#615E66",
    strokeWidth: 0.336918,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.86 370.869C175.778 370.869 178.143 373.234 178.143 376.152V382.756C178.143 385.673 175.778 388.038 172.86 388.038C169.942 388.038 167.577 385.673 167.577 382.756V376.152C167.577 373.234 169.942 370.869 172.86 370.869Z",
    fill: "#E1F1F1",
    stroke: "#615E66",
    strokeWidth: 0.336918,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.521 372.408C175.953 372.408 177.924 374.379 177.924 376.812V382.974C177.924 385.406 175.953 387.377 173.521 387.377C171.088 387.377 169.117 385.406 169.117 382.974V376.812C169.117 374.379 171.088 372.408 173.521 372.408Z",
    fill: "#AACAC9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.638 376.809V396.178",
    stroke: "#615E66",
    strokeWidth: 0.336918,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.94 378.129L172.638 381.801",
    stroke: "#615E66",
    strokeWidth: 0.336918,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.776 381.654L172.637 384.515",
    stroke: "#615E66",
    strokeWidth: 0.336918,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.776 378.129L172.637 380.989",
    stroke: "#615E66",
    strokeWidth: 0.336918,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.705 378.789C191.622 378.789 193.988 381.154 193.988 384.072C193.988 386.99 191.622 389.355 188.705 389.355C185.787 389.355 183.422 386.99 183.422 384.072C183.422 381.154 185.787 378.789 188.705 378.789Z",
    fill: "#E1F1F1",
    stroke: "#615E66",
    strokeWidth: 0.336918,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.705 380.771H189.146C191.457 380.771 193.327 382.645 193.327 384.953C193.327 387.264 191.454 389.134 189.146 389.134H188.705C186.393 389.134 184.523 387.261 184.523 384.953C184.523 382.641 186.397 380.771 188.705 380.771Z",
    fill: "#AACAC9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.486 384.734V395.96",
    stroke: "#615E66",
    strokeWidth: 0.336918,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.565 385.174L188.482 388.257",
    stroke: "#615E66",
    strokeWidth: 0.336918,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.625 385.174L188.708 388.257",
    stroke: "#615E66",
    strokeWidth: 0.336918,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.645 395.962C158.645 395.962 158.568 395.867 158.531 395.82C157.068 393.93 157.506 391.107 159.626 389.786L163.504 387.374C164.103 387.003 164.865 387.017 165.444 387.414L168.887 389.762C170.899 391.137 171.334 393.856 169.996 395.776C169.952 395.837 169.861 395.962 169.861 395.962H158.649H158.645Z",
    fill: "#E1F1F1",
    stroke: "#615E66",
    strokeWidth: 0.336918,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.342 395.7C158.021 394.113 158.446 391.721 160.232 390.683L164.514 388.2C164.989 387.927 165.575 387.934 166.037 388.217L168.971 390.009C171.06 391.283 171.208 394.258 169.258 395.734C169.214 395.767 169.157 395.788 169.096 395.788H159.538C159.46 395.788 159.389 395.754 159.339 395.697L159.342 395.7Z",
    fill: "#AACAC9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.834 392.658V395.96",
    stroke: "#615E66",
    strokeWidth: 0.336918,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.693 391.777L163.833 394.419",
    stroke: "#615E66",
    strokeWidth: 0.336918,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.634 393.1L163.834 395.522",
    stroke: "#615E66",
    strokeWidth: 0.336918,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.866 395.959C187.866 395.959 188.354 395.626 188.573 395.42L189.166 394.864C189.365 394.682 189.506 394.453 189.581 394.197L189.638 394.008C190.052 392.61 188.357 391.556 187.286 392.55V391.802C187.286 390.262 185.349 389.571 184.375 390.767C184.84 388.907 182.707 387.496 181.174 388.655L180.74 388.985L180.625 388.618C180.211 387.341 178.826 386.657 177.563 387.112C176.303 387.566 175.669 388.971 176.164 390.215L176.383 390.767C174.514 390.767 173.466 392.927 174.628 394.396L175.504 395.508C175.635 395.676 175.949 395.959 175.949 395.959H187.866Z",
    fill: "#AACAC9",
    stroke: "#615E66",
    strokeWidth: 0.336918,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.063 395.96L177.701 392.217",
    stroke: "#615E66",
    strokeWidth: 0.336918,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.133 394.486L181.003 391.336",
    stroke: "#615E66",
    strokeWidth: 0.336918,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.592 395.96L186.287 393.76",
    stroke: "#615E66",
    strokeWidth: 0.336918,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.863 393.1L185.548 394.717",
    stroke: "#615E66",
    strokeWidth: 0.336918,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.277 395.961L178.143 389.139",
    stroke: "#615E66",
    strokeWidth: 0.336918,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.752 348.66H92.0693V356.584H101.752V348.66Z",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.8652 350.742V356.581H92.0653V348.906L89.8652 350.739V350.742Z",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.272 359.221H-29.8691V361.862H105.272V359.221Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-30.4008 365.825L-31.9102 363.184H108.15L106.26 365.825H-30.4008Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.155 365.824H91.627V397.959H106.155V365.824Z",
    fill: "#FFF8E7",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.6272 368.465H-15.7822V371.986H91.6272V368.465Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.02894 371.988H-1.25391V397.961H4.02894V371.988Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8746 371.988H14.5918V397.961H19.8746V371.988Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.8434 371.988H29.5605V397.961H34.8434V371.988Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.6091 371.988H42.3262V397.961H47.6091V371.988Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.0138 371.988H56.8516V397.961H63.0138V371.988Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.4204 371.988H70.9375V397.961H78.4204V371.988Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.6275 371.988H84.1445V397.961H91.6275V371.988Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.6306 368.465H88.5479V369.786H91.6306V368.465Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.6268 369.785H88.9854V397.958H91.6268V369.785Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.82448 368.465H-1.69629V369.786H1.82448V368.465Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.38748 369.785H-1.25391V397.958H1.38748V369.785Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6741 368.465H14.1533V369.786H17.6741V368.465Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2332 369.785H14.5918V397.958H17.2332V369.785Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.6399 368.465H29.1191V369.786H32.6399V368.465Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.2019 369.785H29.5605V397.958H32.2019V369.785Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.0471 368.465H44.5264V369.786H48.0471V368.465Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.6092 369.785H44.9678V397.958H47.6092V369.785Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.4544 368.465H59.9336V369.786H63.4544V368.465Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.0165 369.785H60.375V397.958H63.0165V369.785Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.8617 368.465H75.3408V369.786H78.8617V368.465Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.4237 369.785H75.7822V397.958H78.4237V369.785Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-29.9762 357.901L-30.9668 356.58H107.257L106.267 357.901H-29.9762Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-29.9762 359.221L-30.9668 357.9H107.257L106.267 359.221H-29.9762Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-32.1393 363.182L-33.1602 361.861H109.447L108.426 363.182H-32.1393Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.9609 349.537L36.3834 351.299L39.6852 356.582C38.8799 356.582 36.9999 356.538 35.942 356.363C33.8295 355.13 34.035 352.182 34.4022 350.861L33.9609 349.54V349.537Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.336918,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.2031 350.414L34.6256 351.954L37.9274 356.576C37.1222 356.576 35.2422 356.539 34.1842 356.384C32.0718 355.306 32.2773 352.725 32.6445 351.57L32.2031 350.414Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.336918,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.4404 350.857L32.8629 352.289L36.1647 356.582C35.3594 356.582 33.4795 356.545 32.4215 356.403C30.3091 355.402 30.5146 353.004 30.8818 351.932L30.4404 350.857Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.336918,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.2402 351.738L30.6627 352.948L33.9645 356.58C33.1592 356.58 31.2792 356.549 30.2213 356.428C28.1088 355.579 28.3143 353.554 28.6815 352.645L28.2402 351.738Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.336918,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.9199 353.5L29.3423 354.272L32.6442 356.583C31.8389 356.583 29.959 356.563 28.901 356.485C26.7886 355.946 26.9941 354.656 27.3613 354.076L26.9199 353.5Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.336918,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.0856 349.537L41.6631 351.299L38.3613 356.582C39.1666 356.582 41.0466 356.538 42.1045 356.363C44.217 355.13 44.0115 352.182 43.6443 350.861L44.0856 349.54V349.537Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.336918,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.8483 350.414L43.4258 351.954L40.124 356.576C40.9293 356.576 42.8093 356.539 43.8672 356.384C45.9797 355.306 45.7742 352.725 45.407 351.57L45.8483 350.414Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.336918,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.609 350.857L45.1865 352.289L41.8848 356.582C42.69 356.582 44.57 356.545 45.6279 356.403C47.7404 355.402 47.5349 353.004 47.1676 351.932L47.609 350.857Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.336918,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.8102 351.738L47.3877 352.948L44.0859 356.58C44.8912 356.58 46.7712 356.549 47.8291 356.428C49.9416 355.579 49.7361 353.554 49.3689 352.645L49.8102 351.738Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.336918,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.1305 353.5L48.7081 354.272L45.4062 356.583C46.2115 356.583 48.0914 356.563 49.1494 356.485C51.2618 355.946 51.0563 354.656 50.6891 354.076L51.1305 353.5Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.336918,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.0245 355.699C40.6043 355.699 41.885 354.419 41.885 352.839C41.885 351.259 40.6043 349.979 39.0245 349.979C37.4447 349.979 36.1641 351.259 36.1641 352.839C36.1641 354.419 37.4447 355.699 39.0245 355.699Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.025 354.82C40.1191 354.82 41.0061 353.933 41.0061 352.838C41.0061 351.744 40.1191 350.857 39.025 350.857C37.9309 350.857 37.0439 351.744 37.0439 352.838C37.0439 353.933 37.9309 354.82 39.025 354.82Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.072 386.516H94.71V397.961H103.072V386.516Z",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.394 383.873H93.8281V384.752H104.394V383.873Z",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.6397 386.516L93.9355 384.754H104.228L103.17 386.516H94.6397Z",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.872 388.277H97.3516V397.96H100.872V388.277Z",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.753 378.148H96.4697V379.911H101.753V378.148Z",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.9935 389.156H98.2314V393.56H99.9935V389.156Z",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.1111 377.275C100.814 377.275 102.194 375.895 102.194 374.192C102.194 372.49 100.814 371.109 99.1111 371.109C97.4085 371.109 96.0283 372.49 96.0283 374.192C96.0283 375.895 97.4085 377.275 99.1111 377.275Z",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.1102 376.388C100.325 376.388 101.31 375.403 101.31 374.188C101.31 372.973 100.325 371.988 99.1102 371.988C97.8952 371.988 96.9102 372.973 96.9102 374.188C96.9102 375.403 97.8952 376.388 99.1102 376.388Z",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.8893 372.284L94.6467 371.449C94.5659 371.169 94.7781 370.886 95.0746 370.886H96.1662C96.2235 370.886 96.2774 370.876 96.3246 370.856L98.9323 369.855C99.0469 369.811 99.1749 369.818 99.2827 369.872L102.015 371.236C102.126 371.294 102.258 371.297 102.376 371.25L102.837 371.064C103.08 370.967 103.353 371.102 103.423 371.351L103.693 372.277C103.72 372.372 103.717 372.473 103.676 372.56L103.38 373.305C103.322 373.44 103.339 373.591 103.42 373.713L103.612 374.002C103.686 374.117 103.703 374.258 103.666 374.386L103.359 375.3C103.319 375.428 103.336 375.569 103.413 375.684L103.595 375.953C103.683 376.085 103.693 376.253 103.622 376.394L103.393 376.849C103.332 376.974 103.332 377.119 103.393 377.244L103.649 377.749C103.706 377.86 103.71 377.991 103.663 378.109L103.386 378.81C103.329 378.945 103.346 379.097 103.427 379.218L103.575 379.44C103.673 379.588 103.673 379.781 103.575 379.929L103.44 380.131C103.353 380.262 103.343 380.431 103.413 380.572L103.642 381.027C103.703 381.152 103.703 381.297 103.642 381.421L103.383 381.937C103.329 382.041 103.339 382.166 103.407 382.26C103.548 382.476 103.393 382.766 103.134 382.766H95.1757C95.0275 382.766 94.8893 382.691 94.8051 382.57L94.6366 382.318C94.549 382.186 94.539 382.018 94.6097 381.876L94.8388 381.421C94.8994 381.297 94.8994 381.152 94.8388 381.027L94.6097 380.572C94.539 380.431 94.549 380.262 94.6366 380.131L94.7714 379.929C94.8691 379.781 94.8691 379.588 94.7714 379.44L94.6231 379.218C94.5423 379.097 94.5255 378.945 94.5827 378.81L94.859 378.109C94.9062 377.991 94.9028 377.86 94.8455 377.749L94.5895 377.244C94.5288 377.119 94.5288 376.974 94.5895 376.849L94.8354 376.361C94.8961 376.236 94.8961 376.091 94.8354 375.967L94.5794 375.461C94.5221 375.35 94.5187 375.219 94.5659 375.101L94.8422 374.4C94.8995 374.265 94.8826 374.114 94.8017 373.992L94.6164 373.716C94.5355 373.595 94.5187 373.443 94.576 373.308L94.8724 372.564C94.9129 372.473 94.9163 372.372 94.8893 372.281V372.284Z",
    stroke: "#615E66",
    strokeWidth: 0.336918,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-27.9184 351.845L-27.0761 356.225C-27.0357 356.434 -26.8503 356.582 -26.6414 356.582H20.7561C20.9987 356.582 21.1975 356.384 21.1975 356.141V354.975C21.1975 354.874 21.1638 354.776 21.0998 354.699L20.3957 353.82C20.3418 353.752 20.3114 353.671 20.3047 353.587L20.1025 351.576C20.0991 351.535 20.089 351.498 20.0755 351.461L19.4994 349.965C19.368 349.615 18.8526 349.672 18.7987 350.046C18.7414 350.437 18.1956 350.474 18.0844 350.093L18.0675 350.023C17.9563 349.649 17.424 349.659 17.3331 350.036L17.2051 350.545C17.1074 350.936 16.5446 350.922 16.4638 350.528L16.4032 350.211C16.3358 349.891 15.8843 349.881 15.8034 350.198L15.7765 350.309C15.7023 350.599 15.288 350.589 15.2307 350.295C15.1734 350.019 14.7859 349.989 14.6882 350.255L14.4861 350.821C14.3817 351.104 13.974 351.087 13.8965 350.797C13.8055 350.471 13.3338 350.504 13.29 350.838L13.2799 350.892C13.2361 351.246 12.7342 351.269 12.6499 350.922L12.4376 350.016C12.3568 349.692 11.9053 349.669 11.8009 349.989L11.72 350.221C11.6223 350.511 11.2011 350.461 11.1742 350.157C11.1472 349.857 10.7329 349.8 10.6318 350.083L10.5172 350.39C10.406 350.7 9.96805 350.7 9.85687 350.39L9.68504 349.915C9.57049 349.601 9.12233 349.625 9.0381 349.948L8.99097 350.14C8.91685 350.45 8.46876 350.434 8.41485 350.117C8.36095 349.81 7.92971 349.78 7.83874 350.08L7.64667 350.717C7.55907 350.996 7.15818 350.979 7.09754 350.696L7.07056 350.572C7.01665 350.332 6.68642 350.309 6.59882 350.538C6.50785 350.781 6.15075 350.733 6.1238 350.477V350.437C6.09347 350.167 5.7195 350.12 5.62517 350.376L5.54094 350.605C5.42975 350.909 4.99175 350.865 4.94121 350.545L4.90083 350.295C4.85703 349.996 4.43585 349.982 4.3651 350.275L4.35498 350.312C4.2876 350.602 3.8698 350.582 3.83274 350.289L3.80922 350.12C3.76879 349.844 3.3678 349.837 3.33074 350.117C3.28694 350.38 2.91636 350.396 2.85571 350.14L2.79509 349.894C2.72097 349.595 2.28965 349.601 2.22226 349.905L2.16839 350.147C2.08753 350.518 1.56192 350.518 1.48106 350.147L1.46757 350.09C1.38671 349.719 0.867911 349.702 0.763466 350.066L0.68261 350.339C0.564688 350.754 -0.0215386 350.757 -0.149567 350.343C-0.277596 349.921 -0.87731 349.932 -0.991862 350.356L-1.02559 350.491C-1.14351 350.932 -1.77355 350.925 -1.878 350.477L-2.00936 349.911C-2.09359 349.568 -2.58554 349.574 -2.65293 349.921L-2.67982 350.036C-2.74721 350.373 -3.22901 350.363 -3.28292 350.023C-3.33009 349.709 -3.76134 349.665 -3.87252 349.958L-4.03424 350.38C-4.16901 350.74 -4.69801 350.676 -4.75192 350.295C-4.80582 349.891 -5.37856 349.854 -5.483 350.248L-5.54362 350.491C-5.64807 350.875 -6.18715 350.898 -6.31855 350.525L-6.37917 350.363C-6.49709 350.039 -6.95875 350.06 -7.04972 350.39C-7.14742 350.744 -7.65273 350.733 -7.73696 350.376L-7.83805 349.928C-7.91891 349.591 -8.37375 349.547 -8.51526 349.864L-8.63996 350.137C-8.74103 350.366 -9.08131 350.332 -9.13185 350.087C-9.19249 349.81 -9.59006 349.817 -9.64397 350.093L-9.73494 350.548C-9.79559 350.855 -10.2403 350.841 -10.2807 350.531C-10.3211 350.221 -10.7659 350.208 -10.8266 350.514L-10.8602 350.683C-10.9276 351.01 -11.3925 351.01 -11.4599 350.683L-11.4936 350.514C-11.561 350.174 -12.0495 350.181 -12.1101 350.521C-12.1708 350.875 -12.6863 350.848 -12.7301 350.491C-12.7705 350.151 -13.2523 350.103 -13.3433 350.437C-13.4242 350.723 -13.8184 350.75 -13.9329 350.477L-13.9464 350.447C-14.061 350.188 -14.4316 350.184 -14.5461 350.444L-14.7955 351.013C-14.937 351.33 -15.3715 351.367 -15.5669 351.077L-16.1431 350.211C-16.2745 350.012 -16.5743 350.029 -16.6855 350.245C-16.8169 350.514 -17.2178 350.457 -17.2717 350.161L-17.2819 350.103C-17.3492 349.756 -17.8378 349.733 -17.9321 350.076L-17.949 350.151C-18.0366 350.467 -18.4678 350.501 -18.6059 350.204L-18.9597 349.426C-19.0776 349.17 -19.4516 349.2 -19.5291 349.47L-19.6403 349.871C-19.7077 350.113 -20.0615 350.083 -20.085 349.83C-20.1086 349.581 -20.4556 349.547 -20.5297 349.787L-20.5904 350.002C-20.6713 350.258 -21.0318 350.258 -21.1093 350.002L-21.1665 349.81C-21.2642 349.49 -21.7224 349.5 -21.7999 349.824L-21.8404 349.975C-21.9145 350.285 -22.3592 350.268 -22.4165 349.955C-22.4704 349.659 -22.878 349.625 -22.9859 349.908L-23.087 350.188C-23.2116 350.531 -23.7069 350.511 -23.8046 350.157L-23.8653 349.935C-23.9495 349.618 -24.3942 349.608 -24.4986 349.918C-24.5963 350.221 -25.0276 350.221 -25.1253 349.918L-25.1422 349.871C-25.2466 349.554 -25.6981 349.554 -25.8025 349.871L-25.9575 350.336C-26.0316 350.562 -26.3315 350.615 -26.4764 350.43C-26.6583 350.208 -27.0121 350.332 -27.0121 350.619V351.468C-27.0121 351.71 -27.3153 351.818 -27.4703 351.633C-27.6421 351.427 -27.9723 351.586 -27.9251 351.849L-27.9184 351.845Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.205 351.845L103.362 356.225C103.322 356.434 103.137 356.582 102.928 356.582H55.5302C55.2877 356.582 55.0889 356.384 55.0889 356.141V354.975C55.0889 354.874 55.1226 354.776 55.1866 354.699L55.8907 353.82C55.9446 353.752 55.9749 353.671 55.9817 353.587L56.1838 351.576C56.1872 351.535 56.1973 351.498 56.2107 351.461L56.7869 349.965C56.9183 349.615 57.4338 349.672 57.4877 350.046C57.545 350.437 58.0908 350.474 58.202 350.093L58.2188 350.023C58.33 349.649 58.8623 349.659 58.9533 350.036L59.0813 350.545C59.179 350.936 59.7417 350.922 59.8226 350.528L59.8832 350.211C59.9506 349.891 60.4021 349.881 60.4829 350.198L60.5098 350.309C60.5839 350.599 60.9984 350.589 61.0557 350.295C61.1129 350.019 61.5004 349.989 61.5981 350.255L61.8002 350.821C61.9047 351.104 62.3124 351.087 62.3898 350.797C62.4808 350.471 62.9525 350.504 62.9963 350.838L63.0064 350.892C63.0502 351.246 63.5522 351.269 63.6364 350.922L63.8487 350.016C63.9296 349.692 64.381 349.669 64.4855 349.989L64.5663 350.221C64.664 350.511 65.0852 350.461 65.1122 350.157C65.1391 349.857 65.5535 349.8 65.6546 350.083L65.7691 350.39C65.8803 350.7 66.3183 350.7 66.4295 350.39L66.6013 349.915C66.7159 349.601 67.1639 349.625 67.2482 349.948L67.2954 350.14C67.3695 350.45 67.8176 350.434 67.8715 350.117C67.9254 349.81 68.3567 349.78 68.4476 350.08L68.6397 350.717C68.7273 350.996 69.1282 350.979 69.1888 350.696L69.2158 350.572C69.2697 350.332 69.5999 350.309 69.6875 350.538C69.7784 350.781 70.1356 350.733 70.1626 350.477V350.437C70.1929 350.167 70.5669 350.12 70.6612 350.376L70.7454 350.605C70.8566 350.909 71.2946 350.865 71.3451 350.545L71.3855 350.295C71.4293 349.996 71.8505 349.982 71.9213 350.275L71.9314 350.312C71.9988 350.602 72.4166 350.582 72.4536 350.289L72.4771 350.12C72.5176 349.844 72.9186 349.837 72.9556 350.117C72.9994 350.38 73.37 350.396 73.4306 350.14L73.4913 349.894C73.5654 349.595 73.9966 349.601 74.064 349.905L74.118 350.147C74.1988 350.518 74.7244 350.518 74.8053 350.147L74.8188 350.09C74.8996 349.719 75.4184 349.702 75.5229 350.066L75.6037 350.339C75.7217 350.754 76.3079 350.757 76.4359 350.343C76.564 349.921 77.1637 349.932 77.2782 350.356L77.3119 350.491C77.4299 350.932 78.0599 350.925 78.1644 350.477L78.2957 349.911C78.3799 349.568 78.8719 349.574 78.9393 349.921L78.9662 350.036C79.0336 350.373 79.5154 350.363 79.5693 350.023C79.6164 349.709 80.0477 349.665 80.1589 349.958L80.3206 350.38C80.4587 350.74 80.9844 350.676 81.0383 350.295C81.0922 349.891 81.6649 349.854 81.7694 350.248L81.83 350.491C81.9344 350.875 82.4735 350.898 82.6049 350.525L82.6655 350.363C82.7835 350.039 83.245 350.06 83.336 350.39C83.4337 350.744 83.9391 350.733 84.0233 350.376L84.1244 349.928C84.2053 349.591 84.6601 349.547 84.8016 349.864L84.9263 350.137C85.0274 350.366 85.3677 350.332 85.4182 350.087C85.4789 349.81 85.8764 349.817 85.9303 350.093L86.0213 350.548C86.0819 350.855 86.5266 350.841 86.5671 350.531C86.6075 350.221 87.0523 350.208 87.1129 350.514L87.1466 350.683C87.2139 351.01 87.6789 351.01 87.7463 350.683L87.78 350.514C87.8474 350.174 88.3359 350.181 88.3965 350.521C88.4571 350.875 88.9727 350.848 89.0165 350.491C89.0569 350.151 89.5387 350.103 89.6297 350.437C89.7105 350.723 90.1047 350.75 90.2193 350.477L90.2328 350.447C90.3473 350.188 90.7179 350.184 90.8324 350.444L91.0817 351.013C91.2232 351.33 91.6579 351.367 91.8533 351.077L92.4294 350.211C92.5608 350.012 92.8607 350.029 92.9719 350.245C93.1033 350.514 93.5042 350.457 93.5581 350.161L93.5682 350.103C93.6356 349.756 94.1241 349.733 94.2185 350.076L94.2353 350.151C94.3229 350.467 94.7542 350.501 94.8923 350.204L95.2461 349.426C95.364 349.17 95.7379 349.2 95.8154 349.47L95.9266 349.871C95.994 350.113 96.3478 350.083 96.3714 349.83C96.395 349.581 96.742 349.547 96.8161 349.787L96.8768 350.002C96.9576 350.258 97.3181 350.258 97.3956 350.002L97.4529 349.81C97.5506 349.49 98.0088 349.5 98.0863 349.824L98.1267 349.975C98.2009 350.285 98.6456 350.268 98.7028 349.955C98.7568 349.659 99.1644 349.625 99.2722 349.908L99.3733 350.188C99.498 350.531 99.9932 350.511 100.091 350.157L100.152 349.935C100.236 349.618 100.681 349.608 100.785 349.918C100.883 350.221 101.314 350.221 101.412 349.918L101.429 349.871C101.533 349.554 101.984 349.554 102.089 349.871L102.244 350.336C102.318 350.562 102.618 350.615 102.763 350.43C102.945 350.208 103.298 350.332 103.298 350.619V351.468C103.298 351.71 103.602 351.818 103.757 351.633C103.928 351.427 104.259 351.586 104.211 351.849L104.205 351.845Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.3105 356.361L55.3914 352.644C55.4049 352.018 55.9137 351.519 56.5403 351.519C57.1569 351.519 57.6656 352.008 57.6892 352.624L57.8307 356.361L57.9554 352.574C57.979 351.987 58.4608 351.519 59.047 351.519C59.6332 351.519 60.115 351.984 60.1386 352.57L60.2801 356.361L60.4249 352.604C60.4485 351.997 60.9438 351.519 61.5503 351.519C62.1567 351.519 62.6554 351.997 62.6756 352.604L62.8171 356.361L62.9923 352.472C63.0192 351.937 63.4606 351.516 63.9963 351.516C64.5455 351.516 64.9969 351.964 64.9969 352.516V356.357",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.9941 356.361L65.075 352.644C65.0885 352.018 65.5973 351.519 66.2239 351.519C66.8405 351.519 67.3492 352.008 67.3728 352.624L67.5143 356.361L67.639 352.574C67.6626 351.987 68.1444 351.519 68.7306 351.519C69.3168 351.519 69.7986 351.984 69.8222 352.57L69.9637 356.361L70.1085 352.604C70.1321 351.997 70.6274 351.519 71.2339 351.519C71.8403 351.519 72.339 351.997 72.3592 352.604L72.5007 356.361L72.6759 352.472C72.7028 351.937 73.1442 351.516 73.6799 351.516C74.2291 351.516 74.6805 351.964 74.6805 352.516V356.357",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.6797 356.361L74.7605 352.644C74.774 352.018 75.2862 351.519 75.9095 351.519C76.526 351.519 77.0348 352.008 77.0583 352.624L77.1998 356.361L77.3245 352.574C77.3481 351.987 77.8299 351.519 78.4161 351.519C79.0024 351.519 79.4842 351.984 79.5077 352.57L79.6492 356.361L79.7941 352.604C79.8177 351.997 80.313 351.519 80.9194 351.519C81.5259 351.519 82.0245 351.997 82.0447 352.604L82.1862 356.361L82.3614 352.472C82.3884 351.937 82.8297 351.516 83.3654 351.516C83.9146 351.516 84.3661 351.964 84.3661 352.516V356.357",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.3633 356.361L84.4441 352.644C84.4576 352.018 84.9698 351.519 85.5931 351.519C86.2096 351.519 86.7184 352.008 86.7419 352.624L86.8834 356.361L87.0081 352.574C87.0317 351.987 87.5135 351.519 88.0997 351.519C88.686 351.519 89.1678 351.984 89.1913 352.57L89.3328 356.361L89.4777 352.604C89.5013 351.997 89.9966 351.519 90.603 351.519C91.2095 351.519 91.7081 351.997 91.7283 352.604L91.8698 356.361L92.045 352.472C92.072 351.937 92.5133 351.516 93.049 351.516C93.5982 351.516 94.0497 351.964 94.0497 352.516V356.357",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.0498 356.361L94.1307 352.644C94.1441 352.018 94.6563 351.519 95.2796 351.519C95.8962 351.519 96.4049 352.008 96.4285 352.624L96.5699 356.361L96.6946 352.574C96.7182 351.987 97.2 351.519 97.7863 351.519C98.3725 351.519 98.8543 351.984 98.8779 352.57L99.0193 356.361L99.1642 352.604C99.1878 351.997 99.6831 351.519 100.29 351.519C100.896 351.519 101.395 351.997 101.415 352.604L101.556 356.361L101.732 352.472C101.758 351.937 102.2 351.516 102.736 351.516C103.285 351.516 103.736 351.964 103.736 352.516V356.357",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-8.51855 356.361L-8.4377 352.644C-8.42422 352.018 -7.9155 351.519 -7.28884 351.519C-6.67228 351.519 -6.16348 352.008 -6.1399 352.624L-5.99842 356.361L-5.87372 352.574C-5.85013 351.987 -5.36834 351.519 -4.78211 351.519C-4.19587 351.519 -3.71408 351.984 -3.6905 352.57L-3.54902 356.361L-3.40417 352.604C-3.38058 351.997 -2.88528 351.519 -2.27883 351.519C-1.67238 351.519 -1.17379 351.997 -1.15358 352.604L-1.01202 356.361L-0.836815 352.472C-0.809861 351.937 -0.368506 351.516 0.167193 351.516C0.716369 351.516 1.16783 351.964 1.16783 352.516V356.357",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.16504 356.361L1.2459 352.644C1.25937 352.018 1.76809 351.519 2.39476 351.519C3.01132 351.519 3.52011 352.008 3.5437 352.624L3.68518 356.361L3.80988 352.574C3.83346 351.987 4.31525 351.519 4.90149 351.519C5.48772 351.519 5.96951 351.984 5.9931 352.57L6.13458 356.361L6.27943 352.604C6.30301 351.997 6.79831 351.519 7.40476 351.519C8.01121 351.519 8.50988 351.997 8.5301 352.604L8.67158 356.361L8.84678 352.472C8.87373 351.937 9.31509 351.516 9.85079 351.516C10.4 351.516 10.8514 351.964 10.8514 352.516V356.357",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8506 356.361L10.9314 352.644C10.9449 352.018 11.4536 351.519 12.0803 351.519C12.6969 351.519 13.2057 352.008 13.2292 352.624L13.3707 356.361L13.4954 352.574C13.519 351.987 14.0008 351.519 14.587 351.519C15.1733 351.519 15.6551 351.984 15.6786 352.57L15.8201 356.361L15.965 352.604C15.9886 351.997 16.4839 351.519 17.0903 351.519C17.6968 351.519 18.1954 351.997 18.2156 352.604L18.3571 356.361L18.5323 352.472C18.5593 351.937 19.0006 351.516 19.5363 351.516C20.0855 351.516 20.537 351.964 20.537 352.516V356.357",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-0.816028 359.221H0.504746C1.23249 359.221 1.82544 359.81 1.82544 360.541C1.82544 361.269 1.23586 361.862 0.504746 361.862H-0.816028C-1.54377 361.862 -2.13672 361.273 -2.13672 360.541C-2.13672 359.814 -1.54714 359.221 -0.816028 359.221Z",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.0693 353.07C93.5484 353.181 94.7107 354.418 94.7107 355.924V356.584H92.0693V353.07Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.272 353.07C103.793 353.181 102.631 354.418 102.631 355.924V356.584H105.272V353.07Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.0165 354.379C63.0165 353.652 62.4268 353.059 61.6957 353.059C60.9646 353.059 60.375 353.648 60.375 354.379V356.579H63.0165V354.379Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.4208 354.379C78.4208 353.652 77.8311 353.059 77.1 353.059C76.3689 353.059 75.7793 353.648 75.7793 354.379V356.579H78.4208V354.379Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0316 359.221H16.3524C17.0801 359.221 17.6731 359.81 17.6731 360.541C17.6731 361.269 17.0835 361.862 16.3524 361.862H15.0316C14.3039 361.862 13.7109 361.273 13.7109 360.541C13.7109 359.814 14.3005 359.221 15.0316 359.221Z",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.2544 359.221H62.5751C63.3028 359.221 63.8957 359.81 63.8957 360.541C63.8957 361.269 63.3062 361.862 62.5751 361.862H61.2544C60.5266 361.862 59.9336 361.273 59.9336 360.541C59.9336 359.814 60.5233 359.221 61.2544 359.221Z",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.6616 359.221H77.9823C78.71 359.221 79.303 359.81 79.303 360.541C79.303 361.269 78.71 361.862 77.9823 361.862H76.6616C75.9339 361.862 75.3408 361.273 75.3408 360.541C75.3408 359.814 75.9339 359.221 76.6616 359.221Z",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.945175 354.379C0.945175 353.652 0.355513 353.059 -0.375598 353.059C-1.10671 353.059 -1.69629 353.648 -1.69629 354.379V356.579H0.945175V354.379Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7947 354.379C16.7947 353.652 16.2051 353.059 15.474 353.059C14.7429 353.059 14.1533 353.648 14.1533 354.379V356.579H16.7947V354.379Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.072 357.9H94.71V360.542H103.072V357.9Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.685 229.896H248.005L252.14 228.175C253.52 227.601 255.076 227.653 256.409 228.32C257.112 227.622 259.247 226.428 262.188 227.27C258.405 228.113 256.761 230.423 256.409 231.473C255.045 230.449 253.386 229.896 251.68 229.896H251.685Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.29 279.129H336.97L332.835 277.408C331.46 276.834 329.899 276.886 328.565 277.553C327.862 276.85 325.728 275.661 322.786 276.503C326.57 277.346 328.214 279.656 328.565 280.706C329.93 279.682 331.589 279.129 333.295 279.129H333.29Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.499545 244.253H58.3977C60.3854 244.253 61.9998 242.642 61.9998 240.651C61.9998 238.663 60.3885 237.049 58.3977 237.049H53.6875V235.672C53.6875 229.413 46.9773 225.443 41.4924 228.456L38.693 229.993V229.154C38.693 222.866 33.7081 217.604 27.4208 217.502C20.9976 217.394 15.7596 222.57 15.7596 228.965V229.993L14.1175 228.99C8.81789 225.749 2.61076 231.536 5.47203 237.049H0.400791C-1.6487 237.049 -3.29386 238.756 -3.19818 240.824C-3.10558 242.762 -1.43883 244.25 0.499545 244.25V244.253Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.639 280.034H163.326C162.389 280.034 161.59 279.284 161.607 278.349C161.625 277.384 160.849 276.597 159.889 276.597H149.463C148.551 276.597 147.78 275.97 147.534 275.091C146.609 271.78 142.711 269.977 139.5 271.808L138.14 272.582C137.602 272.889 136.915 272.656 136.675 272.085C135.427 269.127 132.403 267.318 129.206 267.623L128.784 267.664C125.011 268.023 122.13 271.191 122.13 274.979C122.13 275.873 121.405 276.595 120.514 276.595H118.752C117.814 276.595 117.015 277.345 117.033 278.28C117.051 279.215 116.275 280.032 115.315 280.032H114.744C113.481 280.032 112.377 280.985 112.295 282.245C112.206 283.625 113.299 284.773 114.662 284.773H119.582C120.388 284.773 121.08 285.418 121.065 286.225C121.049 287.057 121.718 287.736 122.545 287.736H151.885C153.522 287.736 154.849 286.409 154.849 284.773H165.554C166.817 284.773 167.921 283.82 168.003 282.56C168.092 281.179 166.999 280.032 165.636 280.032L165.639 280.034Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.75 230.893H418.262C421.005 230.893 423.228 228.67 423.228 225.926C423.228 223.183 421.005 220.96 418.262 220.96H392.218V219.059C392.218 210.429 382.969 204.958 375.406 209.11L371.547 211.231V209.811C371.547 201.079 364.468 194 355.736 194C347.004 194 339.926 201.079 339.926 209.811V211.231L337.658 209.847C330.351 205.378 321.795 213.356 325.735 220.96H318.742C315.998 220.96 313.775 223.183 313.775 225.926C313.775 228.67 315.998 230.893 318.742 230.893H318.75Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7001_60015",
    x1: 34.3135,
    y1: -0.0000252677,
    x2: 291,
    y2: 773,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.539469,
    stopColor: "#C0F1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E7A9B0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_7001_60015",
    x1: -341.699,
    y1: 598.249,
    x2: -266.554,
    y2: 1002.07,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F7C6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#727BBA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_7001_60015",
    x1: 272.996,
    y1: 557.828,
    x2: 272.996,
    y2: 575.814,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#999999"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_7001_60015",
    x1: 317.054,
    y1: 290,
    x2: 317.054,
    y2: 401,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CADCE3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B4AD9F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_7001_60015",
    x1: 317.054,
    y1: 290,
    x2: 317.054,
    y2: 401,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CADCE3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B4AD9F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_7001_60015",
    x1: 224.007,
    y1: 413.81,
    x2: 232.599,
    y2: 412.813,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFDFDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7001_60015"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 375,
    height: 575,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackPlanMobile);
export default __webpack_public_path__ + "static/media/BackPlanMobile.493b44a38e7cdb863b6a.svg";
export { ForwardRef as ReactComponent };